// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:22.818Z
// Property: Overlook at Flanders (ID: 6767906449166334)
// Collections: 33 amenities, 3 floorplans (live), 42 photos, 80 POIs, 4 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166334",
  "property_external_id": "999",
  "property_zillow_url": "https://www.zillow.com/apartments/flanders-nj/overlook-at-flanders/Cp4kWv/",
  "property_apartments_url": "https://www.apartments.com/overlook-at-flanders-flanders-nj/ytwewcr/",
  "property_google_business_url": "https://www.google.com/maps/place/Overlook+at+Flanders+Apartment+Homes/data=!4m2!3m1!1s0x0:0x468a3e378b009d14?sa=X&ved=2ahUKEwjPobjvyriSAxUnlYkEHVIjNOUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "51224418207",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "overlook-at-flanders",
  "property_name": "Overlook at Flanders",
  "property_website_url": "https://www.liveoverlook.com/",
  "property_domain": "https://www.liveoverlook.com/",
  "property_address": "100 Oakwood Village",
  "property_full_address": "100 Oakwood Village, Flanders, NJ 07836",
  "property_address_1": "100 Oakwood Village",
  "property_address_2": null,
  "property_address_city": "Flanders",
  "property_address_state": "NJ",
  "property_address_zip_full": "07836",
  "property_address_zip": "07836",
  "property_address_country": "US",
  "property_address_county": "Morris County",
  "property_neighborhood_address": "Flanders",
  "property_address_latitude": "40.8566912",
  "property_address_longitude": "-74.699949",
  "property_email": "overlook@aionmanagement.com",
  "property_phone": "(973) 584-1133",
  "property_call_tracking_phone": "844-612-0309",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Scenic Morris County living meets everyday ease.</strong> Explore pet-friendly one- and two-bedroom apartments with room to unwind, refreshed home finishes, and community spaces designed for downtime—then schedule your tour at Overlook at Flanders.</p>",
  "property_long_description": "<p><strong>Scenic Morris County living, with everyday convenience close by.</strong> At Overlook at Flanders, you can choose a classic, modern, or renovated one- or two-bedroom apartment in a pet-friendly Mount Olive setting with room to unwind. Inside, select homes offer hardwood floors, fireplaces, in-home laundry, under-cabinet lighting, and a private patio or balcony; beyond your door, <a href=\"/amenities\">community amenities</a> include a swimming pool with sundeck, fitness center, yoga studio, clubhouse with billiards, EV charging, a pet wash, and two dog parks.</p><p>Your Flanders location keeps the best of western Morris County within easy reach: Turkey Brook Park’s trails and open green space, Flanders Valley Golf Course, Budd Lake, Route 206 dining, and everyday shopping around the International Trade Center and Route 46 corridors. With nearby access to I-80 and the train station just a short drive away, Overlook at Flanders makes it easy to balance quiet, park-like surroundings with the connections you need.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd955-4b76-7718-be0e-3b96ad7f1036.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by lush trees and green grass.",
    "public_id": "019fd955-4b76-7718-be0e-3b96ad7f1036",
    "storage_key": "property/6767906449166334/019fd955-4b76-7718-be0e-3b96ad7f1036.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "1224",
  "property_year_built": "1988",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.73202614379085",
  "property_admin_fee": "100",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow dogs and cats (and service animals), with a maximum of two pets per apartment. There are no weight restrictions.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://overlookatflanders.loftliving.com/login",
  "property_apply_now_url": "https://www.liveoverlook.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0268-5781-746a-86d6-2aecd95fc465.webp",
  "property_primary_logo_media": {
    "alt_text": "Overlook at Flanders Apartment Homes logo.",
    "public_id": "019d0268-5781-746a-86d6-2aecd95fc465",
    "storage_key": "property/6767906449166334/019d0268-5781-746a-86d6-2aecd95fc465.webp",
    "width": 325,
    "height": 125
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-3e2c-778a-b1cb-8aaa45647157.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026b-3e2c-778a-b1cb-8aaa45647157",
    "storage_key": "property/6767906449166334/019d026b-3e2c-778a-b1cb-8aaa45647157.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0268-5781-746a-86d6-2aecd95fc465.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Overlook at Flanders Apartment Homes logo.",
    "public_id": "019d0268-5781-746a-86d6-2aecd95fc465",
    "storage_key": "property/6767906449166334/019d0268-5781-746a-86d6-2aecd95fc465.webp",
    "width": 325,
    "height": 125
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d026b-62aa-7368-a1fd-2a97b083e77a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Overlook at Flanders Apartment Homes logo",
    "public_id": "019d026b-62aa-7368-a1fd-2a97b083e77a",
    "storage_key": "property/6767906449166334/019d026b-62aa-7368-a1fd-2a97b083e77a.webp",
    "width": 325,
    "height": 125
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "765 - 927",
  "property_sqft_min": "765",
  "property_sqft_max": "927",
  "property_price_range": "1911 - 2384",
  "property_price_min": "1911",
  "property_price_max": "2384",
  "property_available_units": 40,
  "property_facebook_url": "https://www.facebook.com/OverlookatFlanders",
  "property_instagram_url": "https://www.instagram.com/overlookatflanders/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/Overlook+at+Flanders+Apartment+Homes/@40.8553644,-74.6992454,17z/data=!4m15!1m8!3m7!1s0x89c39dcd6d693d57:0x468a3e378b009d14!2sOverlook+at+Flanders+Apartment+Homes!8m2!3d40.8553644!4d-74.6992454!10e1!16s%2Fg%2F1tk_knfy!3m5!1s0x89c39dcd6d693d57:0x468a3e378b009d14!8m2!3d40.8553644!4d-74.6992454!16s%2Fg%2F1tk_knfy?entry=ttu&g_ep=EgoyMDI2MDkyNy4xIKXMDSoASAFQAw%3D%3D",
  "property_youtube_url": "https://www.youtube.com/shorts/_npeilovWi0",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Shared+Office+Spaces&find_loc=Lebanon+Township%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Overlook at Flanders",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p><strong>Amenities with momentum.</strong> Start in the fitness center or yoga studio, cool off at the pool and sundeck, then unwind by the outdoor fireplace or over billiards in the clubhouse. Two dog parks and a pet wash add everyday ease, while select homes feature hardwood floors, fireplaces, in-home laundry, and private outdoor space. EV charging, garage parking, and flexible lease options round out the convenience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout—and finish—that fits.</strong> Explore one- and two-bedroom apartments in Flanders with Classic, Modern, and Renovated options to compare side by side. Select homes add standout details like hardwood floors, under-cabinet lighting, built-in microwaves, in-home laundry, fireplaces, and private patios or balconies—all connected to community perks like a fitness center, clubhouse, pool, pet-friendly spaces, and garage parking.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at Overlook at Flanders.</strong> Flip through bright kitchens with stainless-steel appliances, comfortable living areas, and select finishes like fireplaces, hardwood-style flooring, and private balconies. The photos also highlight community favorites, including the pool and sundeck, fitness spaces, resident lounge with billiards, fire pit seating, pet-friendly areas, and green views throughout the grounds.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Nature, errands, and Morris County connections meet in Flanders.</strong> From Overlook at Flanders, Route 206 puts bagels, casual dining, and The Gardens at International Drive within easy reach, while Turkey Brook Park and Flanders Valley Golf Course bring fresh air close by. Wooded views, local trails, I-80, and Mount Olive Station keep the neighborhood grounded, scenic, and connected.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details.</strong> Reviews of Overlook at Flanders call out responsive management, quick repairs, spacious well-kept apartments, and a relaxed community feel. From winter plowing to valet trash pickup and on-site laundry, everyday conveniences get plenty of praise—along with outdoor spaces, pet-friendly features, and places to unwind. See why one resident called it “a great place to live.”</p>",
  "property_neighborhood_blurb": "<p><strong>Flanders keeps your day close to nature and connected to what you need.</strong> From Overlook at Flanders, you can head toward Route 206 for fresh-baked bagels, casual dinners at The Market Tavern, and everyday errands around The Gardens at International Drive, then trade the road for open air at Turkey Brook Park or a round at Flanders Valley Golf Course.</p><p>This Mount Olive location gives you a Morris County setting with wooded views, local trails, and quick links to I-80 and Mount Olive Station for trips across northern New Jersey. Explore the map to find your favorite coffee stop, green space, or dinner plan nearby, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that work as hard as your day does.</strong> At Overlook at Flanders, you can move from a workout in the fitness center or yoga studio to a swim on the sundeck, a fireside evening in the outdoor lounge, or a game of billiards in the clubhouse without leaving the community. Pet-friendly living feels especially complete here, with two dog parks and a pet wash that make everyday care easier; review the details on the <a href=\"/pet-policy\">pet policy</a> page.</p><p>Inside, select one- and two-bedroom homes add polished, practical touches like hardwood floors, under-cabinet lighting, fireplaces, in-home laundry, and private outdoor space. EV charging, available garage parking, online service requests, and flexible lease options bring extra ease to your Flanders routine. See the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Overlook at Flanders home?</strong> Choose a one- or two-bedroom apartment in a pet-friendly Mount Olive setting with scenic Morris County surroundings, everyday convenience, and space to unwind. Start your online application today and take the next step toward your new apartment.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Overlook at Flanders leasing team for help finding your way, exploring available one- and two-bedroom apartments, or learning more about scenic Morris County living with everyday convenience close by.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Overlook at Flanders?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in our pet-friendly Mount Olive setting. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space, then choose the finish that fits your day.</strong> Overlook at Flanders gives you a focused collection of one- and two-bedroom apartment homes in Flanders, with Classic, Modern, and Renovated options so you can compare layout, look, pricing, and availability side by side. Select homes add the details that make a floor plan feel more complete—hardwood floors, under-cabinet lighting, a built-in microwave, in-home laundry, a fireplace, or a private patio or balcony.</p><p>Browse the available plans, note the finishes that matter most, then see how each home connects to community conveniences like the fitness center, clubhouse, pool, pet-friendly spaces, and garage parking on the <a href=\"/amenities\">amenities page</a>. When a layout catches your eye, <a href=\"/schedule-a-tour\">schedule a tour</a> to experience it in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces that bring Overlook at Flanders into focus.</strong> Browse photos of bright kitchens with stainless-steel appliances, inviting living rooms with room to unwind, and select details like fireplaces, hardwood-style finishes, and private balconies that make each apartment feel personal. Then look beyond your front door: the gallery captures the pool and sundeck, fitness spaces, resident lounge with billiards, outdoor seating by the fire pit, and green views throughout the community.</p><p>As you scroll, picture how the apartment interiors, pet-friendly spaces, and everyday conveniences come together in Flanders. When a photo catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Overlook at Flanders on the map.</strong> See available one- and two-bedroom apartments alongside the Flanders surroundings that make everyday living easy, from park-like green space and local dining to shopping corridors, I-80 access, and a nearby train station.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with the messy parts planned for.</strong> At Overlook at Flanders, your cats and dogs have more than a place to stay—they have everyday conveniences built into the community. Take your dog to one of two on-site dog parks for fresh-air time close to home, then make cleanup simple with the pet wash after rainy walks or muddy paws.</p><p>Back inside, choose from comfortable one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with select features like private patios or balconies, fireplaces, hardwood floors, and in-home laundry that can make life with pets feel easier. Review the policy details on this page, including pet limits, fees, and breed guidelines, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the pet-friendly spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share scenic Morris County living.</strong> Love the room to unwind, pet-friendly setting, and everyday convenience at Overlook at Flanders? Invite a friend to find their own one- or two-bedroom apartment here—and enjoy the same quiet, park-like surroundings with connections close by.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Overlook at Flanders.</strong><br>From your pet-friendly Mount Olive home, everyday convenience starts here. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to the quiet, park-like setting and easy Morris County connections that make life at Overlook at Flanders feel balanced.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for Overlook at Flanders often point to the everyday details that make a difference: responsive management, quick repairs, well-maintained and spacious apartments, and a relaxed community feel. Residents highlight attentive service—from maintenance requests to winter plowing—and appreciate conveniences like valet trash pickup and on-site laundry options.</p><p>You’ll also see praise for the setting and <a href=\"/amenities\">community amenities</a>, including pet-friendly features, outdoor spaces, and places to unwind. As one resident put it, Overlook at Flanders is “a great place to live.” Read the reviews below to see what stands out most to the people who know the property best.</p>",
  "property_created_at": "1757008629422",
  "property_scheduletour_blurb": "<p><strong>See Overlook at Flanders in person.</strong><br>Tour pet-friendly one- and two-bedroom apartments in a scenic Mount Olive setting, with select homes featuring hardwood floors, fireplaces, in-home laundry, and private outdoor space. Schedule your visit and picture everyday convenience with room to unwind.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The Overlook at Flanders leasing team will be in touch soon. In the meantime, picture scenic Morris County living with pet-friendly one- and two-bedroom apartments, inviting amenities, and a Mount Olive setting that balances quiet, park-like surroundings with everyday convenience.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a closer look before you arrive.</strong> The Overlook at Flanders community virtual tour gives you an easy way to explore the setting from wherever you are, with a walkthrough-style view of the shared spaces that shape daily life here. Move at your own pace, pause on the details that catch your eye, and get a stronger sense of how the community feels beyond still photos.</p><p>Use the tour as your first pass, then continue with the <a href=\"/gallery\">photo gallery</a> or review <a href=\"/amenities\">community amenities</a> for more detail. When you’re ready to see Overlook at Flanders in person, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. Overlook at Flanders",
  "property_seo_title_home": "Overlook at Flanders |  Apartments in Flanders, NJ",
  "property_seo_description_home": "Find your perfect sanctuary at Overlook at Flanders! With pet-friendly spaces, modern amenities, and serene views, your ideal lifestyle starts here.",
  "property_seo_title_floorplans": "Floor Plans | Flanders, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Overlook at Flanders! Explore stylish one and two-bedroom floor plans in beautiful Flanders, NJ. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Flanders, NJ Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Overlook at Flanders! Enjoy a pet-friendly community with a pool, fitness center, and stylish floor plans. Experience comfort today!",
  "property_seo_title_gallery": "Gallery | Apartments in Flanders, NJ",
  "property_seo_description_gallery": "Imagine life at Overlook at Flanders! Enjoy modern amenities, scenic views, and vibrant community spaces. Photos of your future home await!",
  "property_seo_title_virtualtours": "Virtual Tours | Overlook at Flanders Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Overlook at Flanders! Take a virtual tour of our inviting one and two-bedroom apartments in Mount Olive, NJ. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Overlook at Flanders Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Overlook at Flanders! Explore stylish apartments with premier amenities. Use our interactive map for availability and pricing!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Flanders, NJ",
  "property_seo_description_neighborhood": "Experience life at Overlook at Flanders, NJ! Dive into vibrant local favorites and hidden gems near our welcoming community. Adventure awaits!",
  "property_seo_title_contact": "Contact Us | Overlook at Flanders",
  "property_seo_description_contact": "Experience comfort at Overlook at Flanders. With one and two-bedroom options, your perfect home awaits. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Flanders, NJ",
  "property_seo_description_faqs": "Find clear answers to your top questions at Overlook at Flanders. From amenities to leasing, explore our FAQs and experience life in Mount Olive, NJ.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Flanders, NJ",
  "property_seo_description_reviews": "Join our Mount Olive community! Dive into resident experiences, from pet-friendly spaces to stellar amenities. Check out what makes Overlook at Flanders home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Flanders, NJ",
  "property_seo_description_applynow": "Experience comfort at Overlook at Flanders—pet-friendly apartments in NJ featuring modern amenities, a pool, fitness center, and more. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Overlook at Flanders",
  "property_seo_description_residentaccess": "Unlock convenience at Overlook at Flanders! Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Flanders, NJ.",
  "property_seo_title_referafriend": "Refer A Friend | Overlook at Flanders",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Overlook at Flanders and share the joy of modern living in Flanders, NJ. Your community awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | Overlook at Flanders",
  "property_seo_description_scheduletour": "Experience the charm of Overlook at Flanders. Schedule a tour today and envision your new life in our welcoming community nestled in picturesque Flanders, NJ!",
  "property_seo_title_privacy": "Privacy Policy | Overlook at Flanders",
  "property_seo_description_privacy": "Safeguarding your data at Overlook at Flanders. Review our privacy policy to see how we protect your information while you enjoy peaceful Mount Olive living.",
  "property_seo_title_accessibility": "Website Accessibility | Overlook at Flanders",
  "property_seo_description_accessibility": "Experience true digital inclusivity at Overlook at Flanders. Our commitment to accessibility ensures everyone feels at home in Flanders, NJ. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Overlook at Flanders",
  "property_seo_description_sitemap": "Navigate your way through Overlook at Flanders! Find everything you need from amenities to floor plans in our comprehensive sitemap. Start exploring today!",
  "property_seo_title_thankyou": "Thank You | Overlook at Flanders",
  "property_seo_description_thankyou": "Thank you for reaching out to Overlook at Flanders! We’ll connect soon to help you find your perfect home in Mount Olive, NJ’s serene community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Flanders, NJ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651439",
  "amenities": [
    {
      "id": "custom_6f4c3e94-b90f-4fcb-b10e-d02d5f95224d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdddd149-7ed6-4e9d-ab4c-ffafc47b5a63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd4f626f-5aae-4475-b654-779fbb67abca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf54a094-51d8-44be-a47e-7bb0556cb371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Flex Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7fd18289-134f-4f0b-b4d6-f08d04bac9c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbadd482-ba6c-4df8-9f46-3264ab881d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9ad2f52-ed2d-422d-951f-7702981bd572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef88f688-dc4c-4ee0-85e7-8c8c1ee94743",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8ce962e3-ebaf-42ba-921a-5a152e0dbbc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b048844-d3d4-48e2-9e9e-75f787751984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fe54683-cbe1-4874-8955-ee5742f97b83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse & Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5de5a888-b9db-449b-9024-1236c3987711",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e23e826-3bad-4d79-a7d1-d8021c25b0ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9174a04b-4c45-4644-97e2-02da515fa54f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_991405d9-d41c-4eb0-9b23-4b07545d2c94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0064e23a-c7d4-4455-b6a8-a7b8182b5d58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2aff712a-762a-4620-9545-71a920a95eb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b19c1fdc-7c14-4704-aa5f-3ddd60b0b23c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccf4ee37-f2d9-4dd9-844e-f372d35ce06f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be3179d7-8e7c-4711-b129-19e667355ccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eeb20f48-c2d1-45ac-af57-14e4a03bcc84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer/Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b399e5ce-749b-4a80-a8e5-f93060b782f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpet in Bedrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2bcea7ab-b33e-41c1-9663-440b1dd7ea60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios or Balconies Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42739eda-333d-4b3c-b9cb-a85c0b5c81bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Under-Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35452432-013a-4e73-b12d-cd20368fa016",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Only 4 Miles to the Train Station",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6712d276-6e0e-488e-9805-eb94e3a32bf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddbb851d-9f35-4009-a9b2-da8bb38b1bfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Garage Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d486454-d734-4254-ba85-b4117d58d0a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea07bdf7-8342-4e11-87b4-84edd83f33c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge with Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddb4fd64-ff21-4f25-979c-66f0fedac750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b83348a7-5cad-4c80-ad2c-5caa3b56bb0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f7bfc81-f27d-4b65-8821-c497f057df79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Two Dog Parks",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea3da4f7-580d-4772-8966-b704f953d3d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b0000775-e5c9-4985-8a9c-3583ba9d3f7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-ef6d-744c-a55d-c325be8c02db.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "01a140c1-ef6d-744c-a55d-c325be8c02db",
        "storage_key": "property/6767906449166334/01a140c1-ef6d-744c-a55d-c325be8c02db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white shaker cabinets, quartz countertops, stainless steel appliances including a microwave, range, and dishwasher, and a deep sink.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0db81e04-392f-437d-9a80-f61006440e89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a14106-4373-72ee-affd-2fa26036c7c9.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area visible in the background.",
        "public_id": "01a14106-4373-72ee-affd-2fa26036c7c9",
        "storage_key": "property/6767906449166334/01a14106-4373-72ee-affd-2fa26036c7c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, a modern coffee table, and a well-lit dining space.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and dining area visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_585b1353-7357-4922-a319-9e4a9a891082",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd956-fc6b-7188-8c0a-a19729fc1a78.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fd956-fc6b-7188-8c0a-a19729fc1a78",
        "storage_key": "property/6767906449166334/019fd956-fc6b-7188-8c0a-a19729fc1a78.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a window over the sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/c951e66b0db7577f9d58f5a1b20f9897-1920w.jpg"
    },
    {
      "id": "custom_b5a72428-8b5c-4522-af4b-d37632050f85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a14106-1cea-703e-94fd-68dce385087d.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sectional sofa, coffee table, and accent chair.",
        "public_id": "01a14106-1cea-703e-94fd-68dce385087d",
        "storage_key": "property/6767906449166334/01a14106-1cea-703e-94fd-68dce385087d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully furnished living room, perfect for entertaining or unwinding. Features a comfortable sectional sofa, stylish coffee table, and a cozy accent chair.",
      "link": "",
      "alt_text": "Stylish living room with a sectional sofa, coffee table, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f02169c8-1cb6-49a8-9076-58fc7ae12733",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-e0fe-76ab-b3d1-7e62683cbab2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
        "public_id": "01a140c1-e0fe-76ab-b3d1-7e62683cbab2",
        "storage_key": "property/6767906449166334/01a140c1-e0fe-76ab-b3d1-7e62683cbab2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring stainless steel appliances, ample cabinet space, and sleek quartz countertops. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc5d76de-5d3b-4c26-b926-e4aba4fd5ff6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd956-fc86-70d0-91ae-e09638a3b96c.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and a view of the kitchen and hallway.",
        "public_id": "019fd956-fc86-70d0-91ae-e09638a3b96c",
        "storage_key": "property/6767906449166334/019fd956-fc86-70d0-91ae-e09638a3b96c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright open-concept dining area in an apartment with a modern kitchen and hardwood floors.",
      "link": "",
      "alt_text": "Dining area in an apartment with a dark table, white chairs, and an open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/21a1dd6f2e69ce07f7318f0fab6a48b2-1920w.jpg"
    },
    {
      "id": "custom_4f0eca77-eb36-4659-b4e6-24e1b6ba8ee2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-0674-766a-b7b3-7242f216aaab.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fd957-0674-766a-b7b3-7242f216aaab",
        "storage_key": "property/6767906449166334/019fd957-0674-766a-b7b3-7242f216aaab.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Kitchen in a modern apartment with stainless steel fridge, stove, microwave, white cabinets, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/ad46c1ec7322cf8d26ea31825a473a5e-1920w.jpg"
    },
    {
      "id": "custom_f00278a7-984a-4751-9c40-d34b483ab98e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-077e-717c-846c-4125f6b44d7d.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area",
        "public_id": "019fd957-077e-717c-846c-4125f6b44d7d",
        "storage_key": "property/6767906449166334/019fd957-077e-717c-846c-4125f6b44d7d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area in a modern apartment with a fireplace, contemporary decor, and hardwood floors.",
      "link": "",
      "alt_text": "Living room with gray walls, blue sofas, a glass coffee table, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/96882c8c64d85b8fdb0c955ddbd4dccb-1920w.jpg"
    },
    {
      "id": "custom_0cd7e78c-3bda-407b-b28a-74ace0416686",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd956-fc21-7379-82e5-cb48245fe482.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional sofa, glass coffee table, TV, and sliding glass door.",
        "public_id": "019fd956-fc21-7379-82e5-cb48245fe482",
        "storage_key": "property/6767906449166334/019fd956-fc21-7379-82e5-cb48245fe482.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment model with beige sofa, chairs, wood floors, TV, and sliding glass door to the yard.",
      "link": "",
      "alt_text": "Living room in a modern apartment with sofa, chairs, TV, and sliding door to outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/de8f62dc88af6f7647c7ba259568b27a-1920w.jpg"
    },
    {
      "id": "custom_570308ac-789c-4b76-97b9-fa7d6eab102b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-0939-7507-a596-e84b7f970437.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a dining area.",
        "public_id": "019fd957-0939-7507-a596-e84b7f970437",
        "storage_key": "property/6767906449166334/019fd957-0939-7507-a596-e84b7f970437.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright open-concept apartment kitchen with stainless steel appliances, granite countertops, white cabinets, and a nearby dining area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite counters, white cabinets, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/d5b882ef3ed7ee8b363a2e509fe1b69d-1920w.jpg"
    },
    {
      "id": "custom_c6eeacf0-d1e1-4512-a9fe-fa13516513e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-1102-753c-b8f8-cddd3fdd79bc.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, grey sofa, coffee table, and accent chairs.",
        "public_id": "019fd957-1102-753c-b8f8-cddd3fdd79bc",
        "storage_key": "property/6767906449166334/019fd957-1102-753c-b8f8-cddd3fdd79bc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sectional sofa, glass coffee table, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/41a487aac751501ae01dadfed1e536e9-1920w.jpg"
    },
    {
      "id": "custom_0279afcc-5510-4f1e-a607-c919a6f427a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-dab8-742d-862a-514da5f51342.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, black appliances including refrigerator, dishwasher, microwave, and gas range.",
        "public_id": "01a140c1-dab8-742d-862a-514da5f51342",
        "storage_key": "property/6767906449166334/01a140c1-dab8-742d-862a-514da5f51342.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this charming kitchen, complete with warm wooden cabinetry, a dishwasher, a microwave, and a gas range, offering both style and functionality for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, black appliances including refrigerator, dishwasher, microwave, and gas range.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7df1d8d3-d2af-4595-851d-be18f1784b54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a14104-f7ea-728a-bdf3-83c591cb7aae.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstand, and artwork on the wall.",
        "public_id": "01a14104-f7ea-728a-bdf3-83c591cb7aae",
        "storage_key": "property/6767906449166334/01a14104-f7ea-728a-bdf3-83c591cb7aae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this serene bedroom, featuring a comfortable queen-size bed, stylish nightstand, and tasteful wall art. A large window offers natural light and a view of the community.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-size bed, nightstand, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2c9fe53-ff37-450c-91ad-6f799e7d3d20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-08f3-70f2-b511-4e6f88ee442a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, a desk, and a large window.",
        "public_id": "019fd957-08f3-70f2-b511-4e6f88ee442a",
        "storage_key": "property/6767906449166334/019fd957-08f3-70f2-b511-4e6f88ee442a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom featuring a dark wood bed, matching nightstands, and a desk by the window with orange accents.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a dark wooden bed, two nightstands, and a desk by a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/8e84c774b165aaa99ae80781157fe44c-1920w.jpg"
    },
    {
      "id": "custom_7447cad7-8d50-437b-a129-e3db618de178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd956-fc9f-75c5-ac0e-95f47760229e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a large window overlooking trees.",
        "public_id": "019fd956-fc9f-75c5-ac0e-95f47760229e",
        "storage_key": "property/6767906449166334/019fd956-fc9f-75c5-ac0e-95f47760229e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "A modern bedroom with a gray upholstered bed, two nightstands, a lamp, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/4682385202a9a08297df56c5a057bf80-1920w.jpg"
    },
    {
      "id": "custom_94fec900-8ba4-439a-a662-be95cfa9db21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-865d-7620-8717-1cf6ad5a15b9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub/shower combo.",
        "public_id": "01a140c1-865d-7620-8717-1cf6ad5a15b9",
        "storage_key": "property/6767906449166334/01a140c1-865d-7620-8717-1cf6ad5a15b9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a sleek vanity with a modern faucet, a comfortable toilet, and a clean bathtub and shower combination with a window for natural light.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0552a1cf-129e-48ee-8e59-1494c944b377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c2-0296-7444-a972-51473ed8ccf1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black faucet, and glass-enclosed shower.",
        "public_id": "01a140c2-0296-7444-a972-51473ed8ccf1",
        "storage_key": "property/6767906449166334/01a140c2-0296-7444-a972-51473ed8ccf1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in this stylish bathroom, featuring a sleek vanity with ample storage and a clean glass shower enclosure.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, black faucet, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ffc6df6-2972-49a7-bdb4-dc150ac3be02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-12c6-764d-a627-4e10f9a270ce.webp",
      "image_media": {
        "alt_text": "Bathroom with a tub, toilet, and vanity with a granite countertop and white cabinets.",
        "public_id": "019fd957-12c6-764d-a627-4e10f9a270ce",
        "storage_key": "property/6767906449166334/019fd957-12c6-764d-a627-4e10f9a270ce.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a granite countertop, white cabinetry, and a decorative, spa-like feel.",
      "link": "",
      "alt_text": "Bright apartment bathroom with a granite vanity, large mirror, and tub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/118ecee0f246202c7f281e90f805c6db-1920w.jpg"
    },
    {
      "id": "custom_c56d647c-178d-4cf7-9dd3-0678a42737fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c2-ce24-72b8-862c-c473bbae466b.webp",
      "image_media": {
        "alt_text": "View from a balcony with wood flooring and a black railing overlooking trees and a street.",
        "public_id": "01a140c2-ce24-72b8-862c-c473bbae466b",
        "storage_key": "property/6767906449166334/01a140c2-ce24-72b8-862c-c473bbae466b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze from your private balcony, offering serene views of the surrounding greenery.",
      "link": "",
      "alt_text": "View from a balcony with wood flooring and a black railing overlooking trees and a street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c477477-be9e-420b-9ad1-20c942e2acf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-1ba5-74df-9122-0b9b7892ade0.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with a modern vertical garden wall and large windows.",
        "public_id": "019fd957-1ba5-74df-9122-0b9b7892ade0",
        "storage_key": "property/6767906449166334/019fd957-1ba5-74df-9122-0b9b7892ade0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A modern outdoor patio at a multifamily community with wicker seating, a glass coffee table, and a vertical garden wall.",
      "link": "",
      "alt_text": "Outdoor communal patio with wicker seating and a glass coffee table beside a building wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/2c71ffa86f1e5dc3f2a58aaec23385da-1920w.jpg"
    },
    {
      "id": "custom_7ba7069a-4264-4142-86fc-6b478de4227d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-1eb0-748b-acac-3bca9880b0b2.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, benches, and free weights.",
        "public_id": "019fd957-1eb0-748b-acac-3bca9880b0b2",
        "storage_key": "property/6767906449166334/019fd957-1eb0-748b-acac-3bca9880b0b2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A well-equipped resident gym with resistance machines, free weights, benches, and stability balls.",
      "link": "",
      "alt_text": "Interior fitness center with weight machines, benches, dumbbells, and large exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/8564aa95dba74dcd20d5083b5d011a49-1920w.jpg"
    },
    {
      "id": "custom_38dab5d6-b8c7-41c1-b888-7f54cdae04fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-2ac8-7160-919e-2cb8db5f84a5.webp",
      "image_media": {
        "alt_text": "Two stainless steel grills on a paved patio in a landscaped area.",
        "public_id": "019fd957-2ac8-7160-919e-2cb8db5f84a5",
        "storage_key": "property/6767906449166334/019fd957-2ac8-7160-919e-2cb8db5f84a5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor grilling station in the community area, surrounded by shrubs and a stone retaining wall.",
      "link": "",
      "alt_text": "Two outdoor grills on a concrete pad in a landscaped communal area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/846a0f0fe470881fa85954af1d9060ea-1920w.jpg"
    },
    {
      "id": "custom_6c0839e6-296d-48d9-8366-22db0527f33e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-33df-750c-8c2d-2c7343087c6a.webp",
      "image_media": {
        "alt_text": "Covered porch with columns, chairs, and a table, overlooking trees and a street.",
        "public_id": "019fd957-33df-750c-8c2d-2c7343087c6a",
        "storage_key": "property/6767906449166334/019fd957-33df-750c-8c2d-2c7343087c6a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor balcony at a residential community featuring chairs, a small table, and tree-lined views.",
      "link": "",
      "alt_text": "Balcony with white railings, chairs, and a small round table overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/534c8649091f0b08fa571698a284e36d-1920w.jpg"
    },
    {
      "id": "custom_8bb586b8-8420-4280-afd7-d1a5bc18fe93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-3f5f-725e-88ae-66d634c87321.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit in front of a grey building with a balcony.",
        "public_id": "019fd957-3f5f-725e-88ae-66d634c87321",
        "storage_key": "property/6767906449166334/019fd957-3f5f-725e-88ae-66d634c87321.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with a large patio, seating, and a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/4dc576c233dcbefd8c36531b65e1ca0d-1920w.jpg"
    },
    {
      "id": "custom_84430fc2-55f7-4813-94a0-f322907b32e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-415c-7174-8cf5-89a94078f6cb.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property surrounded by lush green trees.",
        "public_id": "019fd957-415c-7174-8cf5-89a94078f6cb",
        "storage_key": "property/6767906449166334/019fd957-415c-7174-8cf5-89a94078f6cb.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "A sprawling multifamily community featuring multiple residential buildings, green spaces, and a central clubhouse linked by winding roads.",
      "link": "",
      "alt_text": "Aerial view of a large apartment community with brick buildings, roads, and green trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/4f8a9a0f71f191f63a2aea6ce2ce9acf-1920w.jpg"
    },
    {
      "id": "custom_fc41ad27-b77b-4753-9e93-cd4839b69640",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-479e-73fb-b3c7-43da8e94d692.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with garages and surrounding trees.",
        "public_id": "019fd957-479e-73fb-b3c7-43da8e94d692",
        "storage_key": "property/6767906449166334/019fd957-479e-73fb-b3c7-43da8e94d692.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment complex with attached garages, manicured lawn, and mature trees.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with garages, green lawn, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/3fa6a008fac513d3d04baa77d6edd015-1920w.jpg"
    },
    {
      "id": "custom_6b3aad4a-40b6-4204-9d09-99f97c277ae4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fd957-4934-70cc-b6fb-a6f1deaf0f5b.webp",
      "image_media": {
        "alt_text": "Overlook at Flanders monument sign with manicured lawn and apartment buildings in the background.",
        "public_id": "019fd957-4934-70cc-b6fb-a6f1deaf0f5b",
        "storage_key": "property/6767906449166334/019fd957-4934-70cc-b6fb-a6f1deaf0f5b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Overlook at Flanders, featuring beautiful landscaping and well-maintained apartment buildings. Enjoy the serene environment and striking monument signage.",
      "link": "",
      "alt_text": "Exterior view of the Overlook at Flanders apartment community with a manicured lawn and entry sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/88629693/dms3rep/multi/opt/5767906449162442/6767906449166334/fea63398352bbc5f9d5b8f6c0c81eb36-1920w.jpg"
    },
    {
      "id": "custom_3053c353-0c0e-461d-b081-16353518fa5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c2-2983-735f-8bc5-420c8cb8a3a3.webp",
      "image_media": {
        "alt_text": "Exterior of a grey building with white trim and columns, surrounded by greenery and a parking lot.",
        "public_id": "01a140c2-2983-735f-8bc5-420c8cb8a3a3",
        "storage_key": "property/6767906449166334/01a140c2-2983-735f-8bc5-420c8cb8a3a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A well-maintained building exterior with landscaping and a parking area, showcasing the property's community amenities.",
      "link": "",
      "alt_text": "Exterior of a grey building with white trim and columns, surrounded by greenery and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c0e0a818-8ead-4732-8be9-e527a919fe81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c2-022d-72c7-8f99-0f171d1ab01d.webp",
      "image_media": {
        "alt_text": "Modern reception area with seating, chandelier, and large windows.",
        "public_id": "01a140c2-022d-72c7-8f99-0f171d1ab01d",
        "storage_key": "property/6767906449166334/01a140c2-022d-72c7-8f99-0f171d1ab01d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our stunning reception area, featuring a grand chandelier, comfortable seating, and abundant natural light from large windows. A perfect space to relax or work.",
      "link": "",
      "alt_text": "Modern reception area with seating, chandelier, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6764673-ce1d-42d6-a579-96e24739efd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-dff1-764d-ba73-f102fe4f2e9d.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in parking lot with apartment buildings in background.",
        "public_id": "01a140c1-dff1-764d-ba73-f102fe4f2e9d",
        "storage_key": "property/6767906449166334/01a140c1-dff1-764d-ba73-f102fe4f2e9d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations are available for residents in the parking lot, complementing the surrounding apartment buildings and green spaces.",
      "link": "",
      "alt_text": "Electric vehicle charging stations in parking lot with apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f0a398f-2337-4b1f-92c8-059f3d2b6b28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-e683-7694-b15f-d031cde09b55.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and free weights.",
        "public_id": "01a140c1-e683-7694-b15f-d031cde09b55",
        "storage_key": "property/6767906449166334/01a140c1-e683-7694-b15f-d031cde09b55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide selection of cardio machines, weight training equipment, and free weights for a comprehensive workout.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50a53bd5-a5e6-4a90-847a-3571be37e38b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-c44c-716b-a64b-4895ec3e71b1.webp",
      "image_media": {
        "alt_text": "Playground with slides, tunnels, and swings, with apartment buildings in the background.",
        "public_id": "01a140c1-c44c-716b-a64b-4895ec3e71b1",
        "storage_key": "property/6767906449166334/01a140c1-c44c-716b-a64b-4895ec3e71b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides, tunnels, and swings, perfect for families.",
      "link": "",
      "alt_text": "Playground with slides, tunnels, and swings, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8e4a46e-b121-41d6-a823-102b679762cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-c99f-70cf-b180-91401a8a5bb6.webp",
      "image_media": {
        "alt_text": "Covered picnic area with grills and seating.",
        "public_id": "01a140c1-c99f-70cf-b180-91401a8a5bb6",
        "storage_key": "property/6767906449166334/01a140c1-c99f-70cf-b180-91401a8a5bb6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our community picnic area, complete with grills and ample seating for residents.",
      "link": "",
      "alt_text": "Covered picnic area with grills and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a08cdf6-f544-4cef-b711-5b244d5ecbd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-c0b7-766b-95c2-7a791a559f14.webp",
      "image_media": {
        "alt_text": "Pet grooming station with tub and grooming table",
        "public_id": "01a140c1-c0b7-766b-95c2-7a791a559f14",
        "storage_key": "property/6767906449166334/01a140c1-c0b7-766b-95c2-7a791a559f14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Pamper your furry friends at our dedicated pet grooming station, featuring a professional-grade tub and grooming table.",
      "link": "",
      "alt_text": "Pet grooming station with tub and grooming table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24a41c11-35c2-4932-80b1-febadff7e6ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-abd8-77aa-a149-40e9972679b8.webp",
      "image_media": {
        "alt_text": "Modern living area with fireplace and seating",
        "public_id": "01a140c1-abd8-77aa-a149-40e9972679b8",
        "storage_key": "property/6767906449166334/01a140c1-abd8-77aa-a149-40e9972679b8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a cozy fireplace and comfortable seating areas.",
      "link": "",
      "alt_text": "Modern living area with fireplace and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99d55dbd-234b-41b4-b89b-fe531152c9ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-746f-7548-bb3c-058f880c7811.webp",
      "image_media": {
        "alt_text": "Curving swimming pool with lounge chairs and umbrellas under a bright blue sky.",
        "public_id": "01a140c1-746f-7548-bb3c-058f880c7811",
        "storage_key": "property/6767906449166334/01a140c1-746f-7548-bb3c-058f880c7811.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush trees and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Curving swimming pool with lounge chairs and umbrellas under a bright blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c234003-b605-4b58-82cc-4bb4ddc87916",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-89fb-70b9-914b-0eb45ab28fc1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large sectional sofa, coffee table, fireplace, and artwork.",
        "public_id": "01a140c1-89fb-70b9-914b-0eb45ab28fc1",
        "storage_key": "property/6767906449166334/01a140c1-89fb-70b9-914b-0eb45ab28fc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish community lounge, featuring comfortable seating, a cozy fireplace, and contemporary decor.",
      "link": "",
      "alt_text": "Modern lounge area with a large sectional sofa, coffee table, fireplace, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74c9527b-ff22-4378-97d2-01483f3f22be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-8850-7688-8bbb-0d4f290bc9b7.webp",
      "image_media": {
        "alt_text": "Yoga and meditation room with large windows and mirrors.",
        "public_id": "01a140c1-8850-7688-8bbb-0d4f290bc9b7",
        "storage_key": "property/6767906449166334/01a140c1-8850-7688-8bbb-0d4f290bc9b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A serene yoga and meditation room featuring a mirrored wall, a large screen, and floor-to-ceiling windows that offer a view of the outdoors. The words \"breathe, reconnect, balance, relax, tranquility\" are painted on the wall.",
      "link": "",
      "alt_text": "Yoga and meditation room with large windows and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d824c837-0da9-4bdf-ace6-7e33c59e751c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-7100-748f-8138-7f8141fa6886.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "01a140c1-7100-748f-8138-7f8141fa6886",
        "storage_key": "property/6767906449166334/01a140c1-7100-748f-8138-7f8141fa6886.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful swimming pool, complete with comfortable lounge chairs and shaded areas. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_299270b7-df66-46eb-8563-4e543dc3a8cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-7601-72cf-b91e-df6c2d8bb6c0.webp",
      "image_media": {
        "alt_text": "Pool table and cues in a common room with large windows.",
        "public_id": "01a140c1-7601-72cf-b91e-df6c2d8bb6c0",
        "storage_key": "property/6767906449166334/01a140c1-7601-72cf-b91e-df6c2d8bb6c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our stylish community game room, perfect for unwinding and socializing.",
      "link": "",
      "alt_text": "Pool table and cues in a common room with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_017f17a5-091a-49e8-b018-7d51a562b198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-728a-7112-8a0c-7c01922d7a5d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and baby pool area with lounge chairs and lush green trees in the background.",
        "public_id": "01a140c1-728a-7112-8a0c-7c01922d7a5d",
        "storage_key": "property/6767906449166334/01a140c1-728a-7112-8a0c-7c01922d7a5d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and baby pool. Enjoy the beautiful natural surroundings.",
      "link": "",
      "alt_text": "Outdoor swimming pool and baby pool area with lounge chairs and lush green trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56437d2c-42c5-4ca7-98e4-39a817cb18c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a140c1-acaf-71cc-ab14-71c4163ec702.webp",
      "image_media": {
        "alt_text": "Overlook at Flanders monument sign and building exterior.",
        "public_id": "01a140c1-acaf-71cc-ab14-71c4163ec702",
        "storage_key": "property/6767906449166334/01a140c1-acaf-71cc-ab14-71c4163ec702.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Overlook at Flanders, a beautiful community featuring well-maintained grounds and elegant architecture. Enjoy the serene atmosphere and convenient location.",
      "link": "",
      "alt_text": "Overlook at Flanders monument sign and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4fd0326e-d467-4eb3-b6c6-74ec00258ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Joe and Anthony's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "30 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Pizza parlor featuring pies with traditional toppings and custom options served by friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21a7-71eb-85bf-142a069d600f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-21a7-71eb-85bf-142a069d600f",
        "storage_key": "property/6767906449166334/019d0269-21a7-71eb-85bf-142a069d600f.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://joeandanthonys.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3532651856135170226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-and-anthonys-pizzeria",
      "poi_latitude": "40.8822307",
      "poi_longitude": "-74.7075079",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-448-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8ysXNKdw4kRsqgPeCWABjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_cc9cb639-7e08-4c55-a3ae-757cf1c99136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Market Tavern Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "240 US-206 #1, Flanders, NJ 07836, USA",
      "poi_short_description": "Relaxed steakhouse featuring steaks, burgers, wings and seafood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21a7-71eb-85bf-11eae826e2f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-21a7-71eb-85bf-11eae826e2f1",
        "storage_key": "property/6767906449166334/019d0269-21a7-71eb-85bf-11eae826e2f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://markettavernflanders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5134644677250097608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-tavern-restaurant--bar",
      "poi_latitude": "40.8404055",
      "poi_longitude": "-74.7081923",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-584-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4WEPD-cw4kRyKFXIyHsQUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0135c07c-94c3-48af-af26-040d95201f4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Frank's Pizza (Flanders)",
      "poi_type": "Restaurants",
      "poi_address": "240 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "This spot in the Mall at 206 serves pies & an Italian menu (with gluten-free choices), beer & wine.",
      "poi_long_description": "This spot in the Mall at 206 serves pies & an Italian menu (with gluten-free choices), beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21ef-7779-93f7-fab8f20ae7bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-21ef-7779-93f7-fab8f20ae7bc",
        "storage_key": "property/6767906449166334/019d0269-21ef-7779-93f7-fab8f20ae7bc.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.frankspizzaofflanders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13648171688461501106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franks-pizza-flanders",
      "poi_latitude": "40.84062369999999",
      "poi_longitude": "-74.7080057",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-584-0379",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcPlLT-cw4kRsoJK7NYLaL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_63b3f344-8afa-4ef9-bc5f-0077ae58c27a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "The After Char-Broil Grill & Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "195 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-21a6-74cf-8ec5-19a02154f5a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-21a6-74cf-8ec5-19a02154f5a2",
        "storage_key": "property/6767906449166334/019d0269-21a6-74cf-8ec5-19a02154f5a2.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.theaftergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3926256923385915221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-after-char-broil-grill--ice-cream",
      "poi_latitude": "40.8471538",
      "poi_longitude": "-74.70151469999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-584-6564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQz3ojGcw4kRVedVn97dfDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f246481f-52a7-47b3-a73e-ae0e1a15aebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Valentino's Pizzeria & Restaurant (Flanders)",
      "poi_type": "Restaurants",
      "poi_address": "293 US-206 #8, Flanders, NJ 07836, USA",
      "poi_short_description": "Pizza, subs, and other Italian standards served in an informal setting at the Sutton Plaza Shopping Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-26f9-730a-a3cf-d4df83753912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-26f9-730a-a3cf-d4df83753912",
        "storage_key": "property/6767906449166334/019d0269-26f9-730a-a3cf-d4df83753912.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.valentinosflandersnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16146031185105915163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valentinos-pizzeria--restaurant-flanders",
      "poi_latitude": "40.8320854",
      "poi_longitude": "-74.7074441",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-584-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWd-JXxOcw4kRGw2eSNE5EuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8dfd77bb-793d-48fd-8528-46c6f8c89ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mia Nonna's Cucina",
      "poi_type": "Restaurants",
      "poi_address": "380 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "Charming eatery Italian fare with a warm ambiance and outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2881-721d-bc6c-ffdfe554580d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2881-721d-bc6c-ffdfe554580d",
        "storage_key": "property/6767906449166334/019d0269-2881-721d-bc6c-ffdfe554580d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mianonnascucina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1209310572111944273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mia-nonnas-cucina",
      "poi_latitude": "40.8132176",
      "poi_longitude": "-74.71296",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 908-615-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJie6gk8abw4kRUVrb4Y5VyBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ad386e87-f957-4c68-9db2-8af2cfa1cbfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "China House",
      "poi_type": "Restaurants",
      "poi_address": "286 US-206 #107b, Flanders, NJ 07836, USA",
      "poi_short_description": "Small, basic Chinese eatery fixing up noodles, fried rice & other familiar take-out dishes.",
      "poi_long_description": "Small, basic Chinese eatery fixing up noodles, fried rice & other familiar take-out dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2832-73e4-9e91-699895326b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2832-73e4-9e91-699895326b8e",
        "storage_key": "property/6767906449166334/019d0269-2832-73e4-9e91-699895326b8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chinahouseflandersvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8942147373145552244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-house",
      "poi_latitude": "40.831612",
      "poi_longitude": "-74.710611",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-927-7998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyVcVBOcw4kRdHWIiajjGHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_616d44c9-2fdf-4f52-beed-026f0c9ee73f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Efsane Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "286 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "Casual, family-friendly restaurant serving Turkish fare such as baklava and shepherd salad in a BYOB setup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-281d-75bc-8d65-4e327a6bf45a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-281d-75bc-8d65-4e327a6bf45a",
        "storage_key": "property/6767906449166334/019d0269-281d-75bc-8d65-4e327a6bf45a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.efsanemediterraneancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15937327096538785731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "efsane-mediterranean-cuisine",
      "poi_latitude": "40.8317943",
      "poi_longitude": "-74.710495",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 862-219-5340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUFregCdw4kRw-dmAo7CLN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_02d6dec5-69c5-4acb-bbe9-a4f267388c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mount Olive Ginza",
      "poi_type": "Restaurants",
      "poi_address": "3 Mt Olive Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "Relaxed eatery serving a variety of Japanese dishes and sushi rolls, plus Chinese food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2edd-76cb-9c36-d1c2183d7156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2edd-76cb-9c36-d1c2183d7156",
        "storage_key": "property/6767906449166334/019d0269-2edd-76cb-9c36-d1c2183d7156.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.mountoliveginza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342019816480687062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-olive-ginza",
      "poi_latitude": "40.8706976",
      "poi_longitude": "-74.7337526",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-949-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70WcJwidw4kR1sPR72thA1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_54a98191-f1b3-408a-8e7e-b29cdb126993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Budd Lake Diner",
      "poi_type": "Restaurants",
      "poi_address": "120 US-46 West, Budd Lake, NJ 07828, USA",
      "poi_short_description": "Upbeat diner featuring familiar staples like milkshakes and burgers, plus breakfast fare all day.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2f70-777b-8fb3-93630272bec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2f70-777b-8fb3-93630272bec7",
        "storage_key": "property/6767906449166334/019d0269-2f70-777b-8fb3-93630272bec7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.buddlakedinernj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13700769409366676276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "budd-lake-diner",
      "poi_latitude": "40.882042",
      "poi_longitude": "-74.73160659999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-691-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy8glQ56dw4kRNNPWIjDpIr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_35709a1a-ef1c-481a-92a8-25fa1d87219d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "50-J International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-2f70-777b-8fb3-94d6b3e18cdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2f70-777b-8fb3-94d6b3e18cdf",
        "storage_key": "property/6767906449166334/019d0269-2f70-777b-8fb3-94d6b3e18cdf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/nj/flanders/mount-olive/5641?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:flanders-nj-5641_pl:locurl_rd:1553",
      "poi_directions_map_url": "https://maps.google.com/?cid=18307337471761314070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "40.885845",
      "poi_longitude": "-74.708089",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-804-6641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJczqlV-ydw4kRFvGHI2-6EP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ca002f64-57ad-4a61-8961-cdb4250961d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Caffè NaVona",
      "poi_type": "Restaurants",
      "poi_address": "147 US-46, Rockaway, NJ 07866, USA",
      "poi_short_description": "Regional Italian dishes & wines served in a cozy, elegant space with a lounge for live jazz & piano.",
      "poi_long_description": "Regional Italian dishes & wines served in a cozy, elegant space with a lounge for live jazz & piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3176-72ed-8aa2-f97ae90c49bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3176-72ed-8aa2-f97ae90c49bc",
        "storage_key": "property/6767906449166334/019d0269-3176-72ed-8aa2-f97ae90c49bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://caffenavona.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8955833795749272411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caff-navona",
      "poi_latitude": "40.8928585",
      "poi_longitude": "-74.50872580000001",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 973-627-1606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81_VeiQKw4kRW9sSH2ODSXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_49e03564-c8b9-4a51-b571-7c0424f495a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "THE BARN",
      "poi_type": "Restaurants",
      "poi_address": "11 Green Pond Rd, Rockaway, NJ 07866, USA",
      "poi_short_description": "Late-night venue offering eclectic American fare, booze, live bands & a patio in a lively setting.",
      "poi_long_description": "Late-night venue offering eclectic American fare, booze, live bands & a patio in a lively setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-36e5-737f-9e8d-4bd848ab0fea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-36e5-737f-9e8d-4bd848ab0fea",
        "storage_key": "property/6767906449166334/019d0269-36e5-737f-9e8d-4bd848ab0fea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thebarnkitchenandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12817532522511618573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-barn",
      "poi_latitude": "40.9123712",
      "poi_longitude": "-74.50186029999999",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 973-453-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRadYb9YLw4kRDVJSResF4bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4efc1ffe-af55-4386-918d-cb4e7ff6087a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Tavern On the Rocks",
      "poi_type": "Restaurants",
      "poi_address": "9 Wall St, Rockaway, NJ 07866, USA",
      "poi_short_description": "Burgers, wings, and other pub eats are served at this cozy watering hole with 8 beers on tap.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-35c4-721e-a366-aa57686922fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-35c4-721e-a366-aa57686922fd",
        "storage_key": "property/6767906449166334/019d0269-35c4-721e-a366-aa57686922fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tavernontherocks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9752176826322845911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tavern-on-the-rocks",
      "poi_latitude": "40.9012859",
      "poi_longitude": "-74.51424469999999",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 973-453-6358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ade-7234-ad61-a443c4d1a05d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ade-7234-ad61-a443c4d1a05d",
        "storage_key": "property/6767906449166334/019d0269-9ade-7234-ad61-a443c4d1a05d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrd-0BzEKw4kR1wDFfyexVoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_bd435f28-c517-4460-86de-471366a4d466",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "ShopRite of Flanders",
      "poi_type": "Shopping & Retail",
      "poi_address": "90 Bartley Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-355b-7585-806e-dfc966ff1b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-355b-7585-806e-dfc966ff1b01",
        "storage_key": "property/6767906449166334/019d0269-355b-7585-806e-dfc966ff1b01.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=212",
      "poi_directions_map_url": "https://maps.google.com/?cid=14736617780896854274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-flanders",
      "poi_latitude": "40.8348575",
      "poi_longitude": "-74.71230779999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-252-5160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9add-739d-b059-bd178160923d",
        "storage_key": "property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdNehnecw4kRAvEPNcv7gsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2a52265d-efcd-4240-83f0-af67069438f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "40 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Retailer trading in electronics, clothing and shoes, plus groceries and home accessories.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-373b-7145-ba6f-6c708c4fd9ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-373b-7145-ba6f-6c708c4fd9ae",
        "storage_key": "property/6767906449166334/019d0269-373b-7145-ba6f-6c708c4fd9ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/3291-flanders-nj?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14362362110614936948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "40.8819488",
      "poi_longitude": "-74.7082748",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-347-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAbKbJ4ydw4kRdJ27mj5cUcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_059e1b22-1728-4734-a069-8a348b077029",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "194 US-206, Mt Olive, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3abe-722a-b0aa-2f321b34dd41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3abe-722a-b0aa-2f321b34dd41",
        "storage_key": "property/6767906449166334/019d0269-3abe-722a-b0aa-2f321b34dd41.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wawa.com/locations/8446?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=3494379325635103706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.8479559",
      "poi_longitude": "-74.7014422",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 908-315-0335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae0-713c-8960-8bee8952b09c",
        "storage_key": "property/6767906449166334/019d0269-9ae0-713c-8960-8bee8952b09c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJx3CfCWdw4kR2gvzjnuHfjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1a50409b-f72f-4f2c-9a62-a4a63fe20ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "293 US-206 Unit 15B, Flanders, NJ 07836, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3b4e-752b-a781-9de478a7ff56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3b4e-752b-a781-9de478a7ff56",
        "storage_key": "property/6767906449166334/019d0269-3b4e-752b-a781-9de478a7ff56.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/nj/flanders/293-us-hwy-206-unit-15b?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1847378089532161938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.8325533",
      "poi_longitude": "-74.70840489999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 862-251-6919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWd-JXxOcw4kRkn9nqJU0oxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_c0bb0455-e63d-4eb3-ab2e-7dd0248f7dd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Manna Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "286 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "Wide selection of oils, rice and spices (as well as produce, lentils and snacks) at an Indian grocery store with helpful service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3d5f-745d-b482-7291d24cddce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3d5f-745d-b482-7291d24cddce",
        "storage_key": "property/6767906449166334/019d0269-3d5f-745d-b482-7291d24cddce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://order.online/business/manna-supermarket-13819415",
      "poi_directions_map_url": "https://maps.google.com/?cid=11481475531003248825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manna-supermarket",
      "poi_latitude": "40.8321999",
      "poi_longitude": "-74.7100672",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 908-887-6529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9add-739d-b059-bd178160923d",
        "storage_key": "property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT65WbHOdw4kRucDJ-illVp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_9b86485d-78b0-4a51-8f1e-932ec2348a8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "KHAN MARKET",
      "poi_type": "Shopping & Retail",
      "poi_address": "182 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "Internationally inspired market for halal meat, seafood, and produce, plus custom-cut items and prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-3f00-7149-a5a6-c57e130fa959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3f00-7149-a5a6-c57e130fa959",
        "storage_key": "property/6767906449166334/019d0269-3f00-7149-a5a6-c57e130fa959.webp",
        "width": 1104,
        "height": 633
      },
      "poi_business_url": "https://khanmarketusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8571573447452910857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "khan-market",
      "poi_latitude": "40.8746328",
      "poi_longitude": "-74.6919334",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 973-882-1544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9add-739d-b059-bd178160923d",
        "storage_key": "property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsV-7lPqdw4kRCeWZ5aJY9HY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_4583d320-25db-4faa-8126-41418a935260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-406b-74dd-a260-be857b8ebf8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-406b-74dd-a260-be857b8ebf8b",
        "storage_key": "property/6767906449166334/019d0269-406b-74dd-a260-be857b8ebf8b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/NJ-Flanders/1512?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1512-_-na-_-0-_-0&y_source=1_MTE4NDUyOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035637158847493462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.881535",
      "poi_longitude": "-74.702894",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-426-0634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTxRxyY-dw4kRVrWkNbiao2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_053b9f3f-c088-45ce-968b-60a987078182",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "50 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4234-723a-871a-9be53e8556df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4234-723a-871a-9be53e8556df",
        "storage_key": "property/6767906449166334/019d0269-4234-723a-871a-9be53e8556df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=498101966046283798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "40.884586",
      "poi_longitude": "-74.7083372",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-448-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk-AuSKedw4kRFsgcXBmd6QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c7ab13ae-6e3e-470f-94b3-6dc15075f6cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "30 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-456c-737d-bf66-cef6faffc018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-456c-737d-bf66-cef6faffc018",
        "storage_key": "property/6767906449166334/019d0269-456c-737d-bf66-cef6faffc018.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=427887489330598999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "40.882316",
      "poi_longitude": "-74.7060176",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-448-0278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYxncde6dw4kRV1RijWcp8AU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_93670ef2-1077-418a-861d-e28faf9f776b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "294 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4533-771d-857e-cc18f1ae57e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4533-771d-857e-cc18f1ae57e1",
        "storage_key": "property/6767906449166334/019d0269-4533-771d-857e-cc18f1ae57e1.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nj/flanders/294-rt-206-11465?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8996271095107611011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.8303467",
      "poi_longitude": "-74.70943129999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-584-7667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f25-7432-963b-d810c17fa7f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f25-7432-963b-d810c17fa7f9",
        "storage_key": "property/6767906449166334/019d0269-9f25-7432-963b-d810c17fa7f9.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJI059FhOcw4kRg-kAj-Us2Xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7b9db535-88b9-48a8-b4cf-32e56ce9a9b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mountain View Elementary School",
      "poi_type": "Education",
      "poi_address": "118 Clover Hill Dr, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mvs.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4785601333317736110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-view-elementary-school",
      "poi_latitude": "40.8265495",
      "poi_longitude": "-74.7029953",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-927-2201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_T5K5hGcw4kRrhYKtQ7faUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fc96c6ae-754e-417b-b825-a8175601b7a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Tinc Road School",
      "poi_type": "Education",
      "poi_address": "24 Tinc Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trs.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8233271029335766883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tinc-road-school",
      "poi_latitude": "40.8481895",
      "poi_longitude": "-74.72291620000001",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-927-2203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJodofc1Ccw4kRY7cSI2F0QnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_457da362-7077-4399-b4b9-8389cf9d197d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mount Olive High School",
      "poi_type": "Education",
      "poi_address": "18 Corey Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4708-745a-94b7-c1b928dde018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4708-745a-94b7-c1b928dde018",
        "storage_key": "property/6767906449166334/019d0269-4708-745a-94b7-c1b928dde018.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mohs.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13187013154286255594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-olive-high-school",
      "poi_latitude": "40.858611",
      "poi_longitude": "-74.7139961",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-927-2208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdbRb97Sdw4kR6r2ilZiuAbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8a134f79-474c-46da-b689-fa3104de77b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mt Olive Middle School",
      "poi_type": "Education",
      "poi_address": "160 Wolfe Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-49b8-702e-b99b-27cbc9e83084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-49b8-702e-b99b-27cbc9e83084",
        "storage_key": "property/6767906449166334/019d0269-49b8-702e-b99b-27cbc9e83084.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://moms.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2491062619653898465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mt-olive-middle-school",
      "poi_latitude": "40.8469898",
      "poi_longitude": "-74.7467648",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-691-4006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh3g8q--cw4kR4YC5HUEIkiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3b52d8d5-44c2-4256-bb5c-97ab6554e74b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Sandshore Elementary School",
      "poi_type": "Education",
      "poi_address": "498 Sand Shore Rd, Hackettstown, NJ 07840, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ss.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1614528777681873051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandshore-elementary-school",
      "poi_latitude": "40.8628879",
      "poi_longitude": "-74.7728161",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-691-4003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRex-ttecw4kRm6hfgV71ZxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e87edcd8-ce7d-4b7e-8444-a968c143b6f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Chester M. Stephens Elementary School",
      "poi_type": "Education",
      "poi_address": "99 Sunset Dr, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4a11-7269-8275-3e88ac883de7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4a11-7269-8275-3e88ac883de7",
        "storage_key": "property/6767906449166334/019d0269-4a11-7269-8275-3e88ac883de7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cms.motsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3057550364863969046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chester-m-stephens-elementary-school",
      "poi_latitude": "40.8595595",
      "poi_longitude": "-74.7284079",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-691-4002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHW77UKudw4kRFjeVdNuZbio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_21bcd2f0-848c-43bd-902a-8425973880e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Flanders Valley Country Day School",
      "poi_type": "Education",
      "poi_address": "6 Bartley-Chester Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4d46-722a-bbe2-2c819af48b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4d46-722a-bbe2-2c819af48b5b",
        "storage_key": "property/6767906449166334/019d0269-4d46-722a-bbe2-2c819af48b5b.webp",
        "width": 1125,
        "height": 595
      },
      "poi_business_url": "https://flandersvalleycountrydayschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16987901809543780078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flanders-valley-country-day-school",
      "poi_latitude": "40.8269461",
      "poi_longitude": "-74.72031489999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-927-7372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzdJuPXCcw4kR7pYSpbAmwes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3160e7a5-f930-4be9-ad7a-75582c2e90c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Bright Horizons at Mount Olive",
      "poi_type": "Education",
      "poi_address": "101 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-4feb-7596-a704-e8d2208f6722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4feb-7596-a704-e8d2208f6722",
        "storage_key": "property/6767906449166334/019d0269-4feb-7596-a704-e8d2208f6722.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://child-care-preschool.brighthorizons.com/nj/flanders/mountolive?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=18391149892583421204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-mount-olive",
      "poi_latitude": "40.8824236",
      "poi_longitude": "-74.69685609999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-358-2645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz9X1FeWdw4kRFPVlBmN9Ov8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5832996d-93ce-42e2-99d5-d78ea2a71374",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "The Goddard School of Flanders",
      "poi_type": "Education",
      "poi_address": "244 US-206 S, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5025-75a9-8c41-17b37b352ba6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5025-75a9-8c41-17b37b352ba6",
        "storage_key": "property/6767906449166334/019d0269-5025-75a9-8c41-17b37b352ba6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/nj/flanders/flanders?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=7570866532906271682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-flanders",
      "poi_latitude": "40.839309",
      "poi_longitude": "-74.708817",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-598-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMf1fNhWcw4kRwoPF3_8eEWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_2858f8f3-df1b-4418-9a79-b540e34b060d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "County College of Morris",
      "poi_type": "Education",
      "poi_address": "214 Center Grove Rd, Randolph, NJ 07869, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-50d7-7295-aef2-e11edae64a9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-50d7-7295-aef2-e11edae64a9a",
        "storage_key": "property/6767906449166334/019d0269-50d7-7295-aef2-e11edae64a9a.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.ccm.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12455618561383653046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "county-college-of-morris",
      "poi_latitude": "40.85817369999999",
      "poi_longitude": "-74.5814491",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-328-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f14-7149-a5da-d5c9345ecece",
        "storage_key": "property/6767906449166334/019d0269-9f14-7149-a5da-d5c9345ecece.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJQff_xegw4kRtt4IwRY_26w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_170427dc-266d-482d-81e3-485e30d61a66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mayo Performing Arts Center (MPAC)",
      "poi_type": "Entertainment",
      "poi_address": "100 South St, Morristown, NJ 07960, USA",
      "poi_short_description": "Nonprofit community theater hosting readings, plays, performances & live concerts since 1937.",
      "poi_long_description": "Nonprofit community theater hosting readings, plays, performances & live concerts since 1937.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-53f6-755c-98aa-3f0b338b544f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-53f6-755c-98aa-3f0b338b544f",
        "storage_key": "property/6767906449166334/019d0269-53f6-755c-98aa-3f0b338b544f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mayoarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11240132265015052930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-performing-arts-center-mpac",
      "poi_latitude": "40.7943969",
      "poi_longitude": "-74.4778986",
      "poi_miles_from_property": "14.8",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 973-539-8008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzz0nzKKmw4kRggqhBL74_Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_8b59e1cd-5a6e-4552-8e4d-d11a41009ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Morris Museum",
      "poi_type": "Entertainment",
      "poi_address": "6 Normandy Heights Rd, Morristown, NJ 07960, USA",
      "poi_short_description": "Local museum on the outskirts of Morristown hosts cultural exhibits & theatrical performances.",
      "poi_long_description": "Local museum on the outskirts of Morristown hosts cultural exhibits & theatrical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5713-77e8-a084-db5d37eca076.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5713-77e8-a084-db5d37eca076",
        "storage_key": "property/6767906449166334/019d0269-5713-77e8-a084-db5d37eca076.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.morrismuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374821970878289990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-museum",
      "poi_latitude": "40.7960409",
      "poi_longitude": "-74.44829639999999",
      "poi_miles_from_property": "16.2",
      "poi_walking_minutes": "5 hours 56 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 973-971-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f5f-7512-b1a8-c947edc99937",
        "storage_key": "property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_lhZGGmw4kRRlj-CgAQ9SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e2c9fde2-c8a8-4d7e-82f4-7fb84b835039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Historic Speedwell",
      "poi_type": "Entertainment",
      "poi_address": "333 Speedwell Ave, Morristown, NJ 07960, USA",
      "poi_short_description": "19th-c. buildings, including the factory where the telegraph was first demonstrated in 1838.",
      "poi_long_description": "19th-c. buildings, including the factory where the telegraph was first demonstrated in 1838.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-556a-702d-b59c-a90c879317ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-556a-702d-b59c-a90c879317ef",
        "storage_key": "property/6767906449166334/019d0269-556a-702d-b59c-a90c879317ef.webp",
        "width": 640,
        "height": 393
      },
      "poi_business_url": "https://www.morrisparks.net/parks_trails/historic-speedwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17194136043955597731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-speedwell",
      "poi_latitude": "40.8141772",
      "poi_longitude": "-74.48049750000001",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 973-285-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f5f-7512-b1a8-c947edc99937",
        "storage_key": "property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwjrOcOmw4kRo7G2L6LXne4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b6bad080-1ea2-4bef-bc93-1589d950505e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "The Stickley Museum at Craftsman Farms",
      "poi_type": "Entertainment",
      "poi_address": "2352 NJ-10, Morris Plains, NJ 07950, USA",
      "poi_short_description": "Landmark 1911 estate of Arts & Crafts designer Gustav Stickley, with notable grounds & furniture.",
      "poi_long_description": "Landmark 1911 estate of Arts & Crafts designer Gustav Stickley, with notable grounds & furniture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-57f3-77bd-ba37-2cd16917f386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-57f3-77bd-ba37-2cd16917f386",
        "storage_key": "property/6767906449166334/019d0269-57f3-77bd-ba37-2cd16917f386.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stickleymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17545456696068143404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-stickley-museum-at-craftsman-farms",
      "poi_latitude": "40.8560831",
      "poi_longitude": "-74.481828",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 973-540-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f5f-7512-b1a8-c947edc99937",
        "storage_key": "property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44F0nlynw4kRLPkjv-f7ffM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0e5ce080-e024-4810-a7bf-e7e3731e85bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Fosterfields Living Historical Farm",
      "poi_type": "Entertainment",
      "poi_address": "73 Kahdena Rd, Morristown, NJ 07960, USA",
      "poi_short_description": "Visitors can explore this working farm, which uses turn-of-the-century tools & techniques.",
      "poi_long_description": "Visitors can explore this working farm, which uses turn-of-the-century tools & techniques.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5d56-7188-a91c-ebdc8f12c721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5d56-7188-a91c-ebdc8f12c721",
        "storage_key": "property/6767906449166334/019d0269-5d56-7188-a91c-ebdc8f12c721.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.morrisparks.net/parks_trails/fosterfields-living-historical-farm/",
      "poi_directions_map_url": "https://maps.google.com/?cid=179009375140573752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fosterfields-living-historical-farm",
      "poi_latitude": "40.8032773",
      "poi_longitude": "-74.50456199999999",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 973-326-7645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ94jouk-hw4kROPK3CBT4ewI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_f5f53b0a-9107-410f-9757-7a2ec47dedcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Lake Hopatcong Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "State Park, Landing, NJ 07850, USA",
      "poi_short_description": "Located in a former lock tender's house, this museum focuses on Lake Hopatcong's past as a resort.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5cff-7529-9845-70570bc322ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5cff-7529-9845-70570bc322ed",
        "storage_key": "property/6767906449166334/019d0269-5cff-7529-9845-70570bc322ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lakehopatconghistory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050225188643258721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hopatcong-historical-museum",
      "poi_latitude": "40.9165832",
      "poi_longitude": "-74.6650379",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-398-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f5f-7512-b1a8-c947edc99937",
        "storage_key": "property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3mltEl0w4kRYcF_HXmRnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_37d4f0fa-5222-4fb9-b008-9b15315ea8e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "AMC Rockaway 16",
      "poi_type": "Entertainment",
      "poi_address": "363 Mt Hope Ave, Rockaway Township, NJ 07866, USA",
      "poi_short_description": "Movie theater chain in Rockaway Townsquare offering IMAX, Dolby Cinema, and comfortable seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-5eb9-7679-8da1-5f927f801f94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5eb9-7679-8da1-5f927f801f94",
        "storage_key": "property/6767906449166334/019d0269-5eb9-7679-8da1-5f927f801f94.webp",
        "width": 1280,
        "height": 741
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/rockaway/amc-rockaway-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711794955679547328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-rockaway-16",
      "poi_latitude": "40.9097033",
      "poi_longitude": "-74.55804049999999",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 973-328-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a384-75ba-9069-fa89e44beb54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a384-75ba-9069-fa89e44beb54",
        "storage_key": "property/6767906449166334/019d0269-a384-75ba-9069-fa89e44beb54.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzQUk7ELw4kRwL9xJPg47Oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_12538738-e9ec-4fbe-ac73-484ed42275a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Morristown Green",
      "poi_type": "Entertainment",
      "poi_address": "10 N Park Pl, Morristown, NJ 07960, USA",
      "poi_short_description": "The site of George Washington's headquarters in 1777, this park now hosts town festivals & events.",
      "poi_long_description": "The site of George Washington's headquarters in 1777, this park now hosts town festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-604d-72ca-8083-33ce21bf4ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-604d-72ca-8083-33ce21bf4ecc",
        "storage_key": "property/6767906449166334/019d0269-604d-72ca-8083-33ce21bf4ecc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://themorristowngreen.org/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11632338268875468159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morristown-green",
      "poi_latitude": "40.7969973",
      "poi_longitude": "-74.48098379999999",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 973-539-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3S3jrymw4kRfy2BVwZebqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_746d18cb-c49e-4dec-af90-75984d86c98d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "The Frelinghuysen Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "353 E Hanover Ave, Morristown, NJ 07960, USA",
      "poi_short_description": "This 127-acre park offers flower gardens, groves, educational programs & a Colonial Revival mansion.",
      "poi_long_description": "This 127-acre park offers flower gardens, groves, educational programs & a Colonial Revival mansion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-62e7-7028-8fa0-0f4fc42639ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-62e7-7028-8fa0-0f4fc42639ff",
        "storage_key": "property/6767906449166334/019d0269-62e7-7028-8fa0-0f4fc42639ff.webp",
        "width": 512,
        "height": 374
      },
      "poi_business_url": "http://www.morrisparks.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=368114612328992605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-frelinghuysen-arboretum",
      "poi_latitude": "40.8029026",
      "poi_longitude": "-74.451483",
      "poi_miles_from_property": "16.1",
      "poi_walking_minutes": "5 hours 53 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 973-326-7601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHwXkWVmmw4kRXQ-AIErOGwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_a306ecf1-7f67-41f4-b60d-6aa6b5e7cb29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Macculloch Hall Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "45 MacCulloch Ave, Morristown, NJ 07960, USA",
      "poi_short_description": "Mansion built in 1810 with period rooms, gardens & a collection of cartoonist Thomas Nast's work.",
      "poi_long_description": "Mansion built in 1810 with period rooms, gardens & a collection of cartoonist Thomas Nast's work.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-6357-716c-bbf4-c2891ba287f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6357-716c-bbf4-c2891ba287f2",
        "storage_key": "property/6767906449166334/019d0269-6357-716c-bbf4-c2891ba287f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maccullochhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14414360755357738746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macculloch-hall-historical-museum",
      "poi_latitude": "40.79210700000001",
      "poi_longitude": "-74.481753",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 973-538-2404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f5f-7512-b1a8-c947edc99937",
        "storage_key": "property/6767906449166334/019d0269-9f5f-7512-b1a8-c947edc99937.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQ3dd6Smw4kR-uZth7wYCsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ab0b8a3d-632a-431b-a160-c0ae6f67143e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Morristown Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Madison Ave, Morristown, NJ 07960, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-633c-746e-994a-ae41dd4def05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-633c-746e-994a-ae41dd4def05",
        "storage_key": "property/6767906449166334/019d0269-633c-746e-994a-ae41dd4def05.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/morristown-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6835593742196230722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morristown-medical-center",
      "poi_latitude": "40.7894519",
      "poi_longitude": "-74.4658709",
      "poi_miles_from_property": "15.6",
      "poi_walking_minutes": "5 hours 44 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 973-971-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a392-759f-9be6-8a647c5547e3",
        "storage_key": "property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31s7Ppumw4kRQkp9wEro3F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_850fcb08-a903-4f1e-be57-04248840034f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Skylands Urgent Care Flanders",
      "poi_type": "Health and Wellness",
      "poi_address": "Old PNC Bank by Weiss, 293 US-206, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-670c-721b-9786-c50b7775a95a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-670c-721b-9786-c50b7775a95a",
        "storage_key": "property/6767906449166334/019d0269-670c-721b-9786-c50b7775a95a.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://skylandsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16585693901600627069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skylands-urgent-care-flanders",
      "poi_latitude": "40.8325254",
      "poi_longitude": "-74.7084082",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-527-7344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0Y2Q66dw4kRfZlEjro4LOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_d4f2a41b-29d0-4472-8244-3b73da635728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Advocare Family Health at Mt. Olive (PCP)",
      "poi_type": "Health and Wellness",
      "poi_address": "183 US-206 Suite 1, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-683d-748b-8b0a-39acf5b3ce03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-683d-748b-8b0a-39acf5b3ce03",
        "storage_key": "property/6767906449166334/019d0269-683d-748b-8b0a-39acf5b3ce03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.advocarefamilyhealthmtolive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15063872171087270307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "advocare-family-health-at-mt-olive-pcp",
      "poi_latitude": "40.8764136",
      "poi_longitude": "-74.69277009999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 973-347-3277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6q6MuGdw4kRo5GMg-2fDdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_3772a5ea-418f-46e1-9b32-d9a3d4cfe999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "ShopRite Pharmacy of Flanders",
      "poi_type": "Health and Wellness",
      "poi_address": "90 Bartley Flanders Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-68ba-71a6-a552-2974012b2988.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-68ba-71a6-a552-2974012b2988",
        "storage_key": "property/6767906449166334/019d0269-68ba-71a6-a552-2974012b2988.webp",
        "width": 1024,
        "height": 1046
      },
      "poi_business_url": "https://www.shoprite.com/pharmacy/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=212-P",
      "poi_directions_map_url": "https://maps.google.com/?cid=14451443436835432020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-pharmacy-of-flanders",
      "poi_latitude": "40.83495560000001",
      "poi_longitude": "-74.7119668",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-252-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a3a7-770e-95da-1f04a1d18569.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a3a7-770e-95da-1f04a1d18569",
        "storage_key": "property/6767906449166334/019d0269-a3a7-770e-95da-1f04a1d18569.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdx3I2ebw4kRVOY5ID3Xjcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_35a0bb47-1216-4bcc-9bbc-839a43f94957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "40 International Dr S, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-68e3-72fa-b645-62504b462f8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-68e3-72fa-b645-62504b462f8d",
        "storage_key": "property/6767906449166334/019d0269-68e3-72fa-b645-62504b462f8d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3291-flanders-nj/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16823088239184995311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "40.8818414",
      "poi_longitude": "-74.70841229999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-347-8060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a3a7-770e-95da-1f04a1d18569.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a3a7-770e-95da-1f04a1d18569",
        "storage_key": "property/6767906449166334/019d0269-a3a7-770e-95da-1f04a1d18569.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYS0w--dw4kR72Os-Z6dd-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d39b160d-b44a-4a22-b1f8-c24a4be96b21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "255 US-46, Budd Lake, NJ 07828, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-6d12-7142-beeb-aa33fac24ee9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6d12-7142-beeb-aa33fac24ee9",
        "storage_key": "property/6767906449166334/019d0269-6d12-7142-beeb-aa33fac24ee9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/budd-lake-nj-pharmacies/255-rte-46-budd-lake-nj-07828/storeid=2092?WT.mc_id=LS_GOOGLE_FS_2092",
      "poi_directions_map_url": "https://maps.google.com/?cid=1518788396286164052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.867891",
      "poi_longitude": "-74.7393779",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-448-9051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyj3Kwidw4kRVDyf4f_RExU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_0998043b-8f7c-4fcc-832e-1b8f9627aff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Gold's Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "90 Bartley Flanders Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-6ea6-72bd-b2d9-c152c22584ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6ea6-72bd-b2d9-c152c22584ea",
        "storage_key": "property/6767906449166334/019d0269-6ea6-72bd-b2d9-c152c22584ea.webp",
        "width": 750,
        "height": 508
      },
      "poi_business_url": "https://www.goldsgym.com/flandersnj/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1262018063884180046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym",
      "poi_latitude": "40.8342316",
      "poi_longitude": "-74.7128501",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-584-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcBYhnecw4kRTlrxHb6WgxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0ca51c0-a82e-48d6-a25c-982f54feec78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Topshelf Fitness Center & Supplement Store",
      "poi_type": "Health and Wellness",
      "poi_address": "90 US-206 #230, Stanhope, NJ 07874, USA",
      "poi_short_description": "Well-equipped gym featuring a powerlifting station, open 24/7.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-6ef3-7543-9bfe-df380f0d2a57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6ef3-7543-9bfe-df380f0d2a57",
        "storage_key": "property/6767906449166334/019d0269-6ef3-7543-9bfe-df380f0d2a57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://linktr.ee/Topshelffitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=3239371754607281415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topshelf-fitness-center--supplement-store",
      "poi_latitude": "40.9354057",
      "poi_longitude": "-74.72019949999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-426-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZR5TaZ3w4kRBwXNqHKP9Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c2d223ad-64c4-4a17-97fb-baf00f040201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Atlantic Health Urgent Care at Ledgewood",
      "poi_type": "Health and Wellness",
      "poi_address": "501 NJ-10, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-6ff5-772d-af92-8705c0553af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6ff5-772d-af92-8705c0553af3",
        "storage_key": "property/6767906449166334/019d0269-6ff5-772d-af92-8705c0553af3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/urgent-care-ledgewood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2295486677193665147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-health-urgent-care-at-ledgewood",
      "poi_latitude": "40.8761818",
      "poi_longitude": "-74.6507656",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-584-6751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UVLXdCfw4kReyrFjPg02x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_26584934-5ba7-41bf-886a-2dfb360bc69a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Hackettstown Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "651 Willow Grove St, Hackettstown, NJ 07840, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-72c2-7618-9ea9-4105e497fdc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-72c2-7618-9ea9-4105e497fdc3",
        "storage_key": "property/6767906449166334/019d0269-72c2-7618-9ea9-4105e497fdc3.webp",
        "width": 816,
        "height": 460
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/hackettstown-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1221854247470668786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hackettstown-medical-center",
      "poi_latitude": "40.8616623",
      "poi_longitude": "-74.81592789999999",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 908-852-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a392-759f-9be6-8a647c5547e3",
        "storage_key": "property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJybIMMQWDw4kR8pvK4_bl9BA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_37e0e711-1d1d-4472-835f-8cf76d057f2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Flanders Park Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "40 Flanders-Bartley Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7485-7330-82a1-ee3e8609e0d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-7485-7330-82a1-ee3e8609e0d2",
        "storage_key": "property/6767906449166334/019d0269-7485-7330-82a1-ee3e8609e0d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13404646309719387294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flanders-park-playground",
      "poi_latitude": "40.8341566",
      "poi_longitude": "-74.6978822",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWOhgE2dw4kRniyTPszeBro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_a129404a-e149-41b7-83bb-f81eb460bfd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Turkey Brook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "30 Flanders Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "Expansive park with paved & unpaved trails, water features & enclosed off-leash areas for dogs.",
      "poi_long_description": "Expansive park with paved & unpaved trails, water features & enclosed off-leash areas for dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-74d2-766c-b88c-13b267f245b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-74d2-766c-b88c-13b267f245b7",
        "storage_key": "property/6767906449166334/019d0269-74d2-766c-b88c-13b267f245b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mountolivetwpnj.org/parks-buildings-grounds/page/turkey-brook-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=474238994455826165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turkey-brook-park",
      "poi_latitude": "40.8653628",
      "poi_longitude": "-74.72534499999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-691-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqW2xuLOdw4kR9Y4tU9rVlAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_53d67b0f-3019-4d46-93f1-cc17e0205787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Hopatcong State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "260 Lakeside Blvd, Landing, NJ 07850, USA",
      "poi_short_description": "Park with aquatic recreation options, including boating, swimming & fishing, plus an athletic field.",
      "poi_long_description": "Park with aquatic recreation options, including boating, swimming & fishing, plus an athletic field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7516-77fd-8669-3d3d9003eea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-7516-77fd-8669-3d3d9003eea3",
        "storage_key": "property/6767906449166334/019d0269-7516-77fd-8669-3d3d9003eea3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nj.gov/dep/parksandforests/parks/hopatcongstatepark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11304170543698965182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopatcong-state-park",
      "poi_latitude": "40.9159878",
      "poi_longitude": "-74.66423379999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-398-7010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxSgFh8B1w4kRvnKcqTd74Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_3783d083-20d0-4e6a-949c-8fa3bc0941c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Hacklebarney State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "119 Hacklebarney Rd, Long Valley, NJ 07853, USA",
      "poi_short_description": "1200-acre park hosting a fish-stocked river, hiking-only trails & hunting on 600 acres.",
      "poi_long_description": "1200-acre park hosting a fish-stocked river, hiking-only trails & hunting on 600 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-784c-7365-8fcc-4246a6bea32f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-784c-7365-8fcc-4246a6bea32f",
        "storage_key": "property/6767906449166334/019d0269-784c-7365-8fcc-4246a6bea32f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.nj.gov/dep/parksandforests/parks/hacklebarneystatepark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17357849144035963650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hacklebarney-state-park",
      "poi_latitude": "40.7511417",
      "poi_longitude": "-74.7364025",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 908-638-8572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5zGZ0aaw4kRAvMUp9R34_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_0fcb6830-a3d5-40c8-8715-d59380c124a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Schooley's Mountain Park Main Entrance",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "91 E Springtown Rd, Long Valley, NJ 07853, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7b21-74be-8b09-b488dcc3d117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-7b21-74be-8b09-b488dcc3d117",
        "storage_key": "property/6767906449166334/019d0269-7b21-74be-8b09-b488dcc3d117.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=709929575766139485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schooleys-mountain-park-main-entrance",
      "poi_latitude": "40.804583",
      "poi_longitude": "-74.78526889999999",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82vr0s6Ew4kRXaIVEzAt2gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ab26774e-4b05-49d2-9b66-a14829e321f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Bamboo Brook Outdoor Education Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 Longview Rd, Far Hills, NJ 07931, USA",
      "poi_short_description": "Landscaped grounds and hiking trails on a property designed by one of the first female landscape architects in America.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7b2d-77af-97b3-c1da1e2b3efd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-7b2d-77af-97b3-c1da1e2b3efd",
        "storage_key": "property/6767906449166334/019d0269-7b2d-77af-97b3-c1da1e2b3efd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.morrisparks.net/parks_trails/bamboo-brook-outdoor-education-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7349213990217737064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bamboo-brook-outdoor-education-center",
      "poi_latitude": "40.73143779999999",
      "poi_longitude": "-74.7073006",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 973-326-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoxfvA5mQw4kRaGNCsS-n_WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_b2d80fc0-6b44-4887-9339-ca38ee89f881",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Willowwood Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Longview Rd, Far Hills, NJ 07931, USA",
      "poi_short_description": "Well-kept garden displays, as well as a redwood tree, all within a tranquil arboretum.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-7bad-7600-af96-d126e5440cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-7bad-7600-af96-d126e5440cc5",
        "storage_key": "property/6767906449166334/019d0269-7bad-7600-af96-d126e5440cc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willowwoodarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=382426305956625733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willowwood-arboretum",
      "poi_latitude": "40.7290081",
      "poi_longitude": "-74.6998711",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a4f3-7772-a73b-5941e2519dd8",
        "storage_key": "property/6767906449166334/019d0269-a4f3-7772-a73b-5941e2519dd8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbZkkLyQw4kRRT1P97KmTgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_8624d70d-67a9-4530-9547-c5510a208756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Riamede Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "122 Oakdale Rd, Chester, NJ 07930, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-8008-7328-9d50-b798053e87b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-8008-7328-9d50-b798053e87b0",
        "storage_key": "property/6767906449166334/019d0269-8008-7328-9d50-b798053e87b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.riamedefarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16823923219910717541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riamede-farm",
      "poi_latitude": "40.7947699",
      "poi_longitude": "-74.6924052",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 908-879-7762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-_yQ-ebw4kRZXA5EwiVeuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_444a91a4-07f9-4119-8673-984991b0d3aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Alstede Farms",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Alstede Farms Ln, Chester, NJ 07930, USA",
      "poi_short_description": "Family-run farm featuring seasonal fruit and vegetable picking, as well as baked goods and ice cream.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-830e-7588-a393-95b9f5fb422e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-830e-7588-a393-95b9f5fb422e",
        "storage_key": "property/6767906449166334/019d0269-830e-7588-a393-95b9f5fb422e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://alstedefarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15006930812210341455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alstede-farms",
      "poi_latitude": "40.7789241",
      "poi_longitude": "-74.7137164",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 908-879-7189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9add-739d-b059-bd178160923d",
        "storage_key": "property/6767906449166334/019d0269-9add-739d-b059-bd178160923d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-1kMguZw4kRT2apRhBUQ9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_99f5f1c8-6892-4015-b650-2f4136ed5a59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Stony Hill Farm Market",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15 North Rd, Chester, NJ 07930, USA",
      "poi_short_description": "Large family farm featuring a corn maze picking areas for apples and pumpkins, a playground, a shop and kids' games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-811f-71eb-aad6-e10085dcfd21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-811f-71eb-aad6-e10085dcfd21",
        "storage_key": "property/6767906449166334/019d0269-811f-71eb-aad6-e10085dcfd21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stonyhillfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4956218081677006349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stony-hill-farm-market",
      "poi_latitude": "40.7902777",
      "poi_longitude": "-74.67995049999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 908-879-2908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj_M0GWeZw4kRDda5CxYGyEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_eb22709f-7a52-4ea0-ad1c-8527f6bafa94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Netcong",
      "poi_type": "Transportation & Transit",
      "poi_address": "Maint St & Rt 46, Netcong, NJ 07857, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-829f-72d1-b314-bb8b98e03de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-829f-72d1-b314-bb8b98e03de8",
        "storage_key": "property/6767906449166334/019d0269-829f-72d1-b314-bb8b98e03de8.webp",
        "width": 1024,
        "height": 697
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=101",
      "poi_directions_map_url": "https://maps.google.com/?cid=4390239815921802326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "netcong",
      "poi_latitude": "40.8975045",
      "poi_longitude": "-74.7073052",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-275-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a778-76e6-a356-5202ccd76fdd",
        "storage_key": "property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTnv_x52w4kRVpzLItpD7Tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_3b5d1af4-eb87-403c-9faa-52f44a0a1d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Mount Olive",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mt Olive, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-84e6-7015-acef-afb3e23e47dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-84e6-7015-acef-afb3e23e47dd",
        "storage_key": "property/6767906449166334/019d0269-84e6-7015-acef-afb3e23e47dd.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7681081535091119717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-olive",
      "poi_latitude": "40.9074311",
      "poi_longitude": "-74.7307773",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a778-76e6-a356-5202ccd76fdd",
        "storage_key": "property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQQ9nS12w4kRZRbrxfWumGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_aaa1c0c9-9c6d-4afd-8b3a-42f8c41bc131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Parking Lot - Mount Arlington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7 Howard Blvd, Kenvil, NJ 07847, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.njtransit.com/dv-to/Mount%20Arlington%20Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=15167676676914606093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-lot---mount-arlington-station",
      "poi_latitude": "40.89712600000001",
      "poi_longitude": "-74.633015",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-275-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a7d7-71ad-8360-fdd03c3685d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a7d7-71ad-8360-fdd03c3685d3",
        "storage_key": "property/6767906449166334/019d0269-a7d7-71ad-8360-fdd03c3685d3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZXe3nB1w4kRDfB4a5NpftI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_eb30055c-5253-42e6-b043-4012acf2c828",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Lake Hopatcong",
      "poi_type": "Transportation & Transit",
      "poi_address": "Roxbury Township, NJ 07850, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-85d1-7627-8239-23d004c6edd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-85d1-7627-8239-23d004c6edd2",
        "storage_key": "property/6767906449166334/019d0269-85d1-7627-8239-23d004c6edd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910139811642599003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hopatcong",
      "poi_latitude": "40.9040904",
      "poi_longitude": "-74.6655462",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a778-76e6-a356-5202ccd76fdd",
        "storage_key": "property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xdXfet1w4kRW-ZdUCl1684",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e35bbb3f-060f-4f3c-9448-7b2d65f0e350",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Hackettstown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Hackettstown, NJ 07840, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-87e8-7656-a9d2-978b9dc9cb13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-87e8-7656-a9d2-978b9dc9cb13",
        "storage_key": "property/6767906449166334/019d0269-87e8-7656-a9d2-978b9dc9cb13.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4995703213226886062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hackettstown",
      "poi_latitude": "40.8519642",
      "poi_longitude": "-74.8347218",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a778-76e6-a356-5202ccd76fdd",
        "storage_key": "property/6767906449166334/019d0269-a778-76e6-a356-5202ccd76fdd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyP_7ZiDw4kRroOqo5pNVEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_9e8da0a8-be48-47bf-98cc-ec5ea505290a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Hopatcong Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "47 Hopatchung Rd, Hopatcong, NJ 07843, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hellergroup.com/properties/hopatcong-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5646856226792664617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopatcong-plaza",
      "poi_latitude": "40.9351672",
      "poi_longitude": "-74.6616801",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8bcBukl0w4kRKe6t59GpXU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6de283b7-ca66-4730-a1ba-82adc86a85a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Newark Liberty International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark International Airport St, Newark, NJ 07114, USA",
      "poi_short_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_long_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-887d-70ad-800f-2f76c0de42ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-887d-70ad-800f-2f76c0de42ba",
        "storage_key": "property/6767906449166334/019d0269-887d-70ad-800f-2f76c0de42ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newarkairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12966905903765254790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-liberty-international-airport",
      "poi_latitude": "40.6884837",
      "poi_longitude": "-74.17686359999999",
      "poi_miles_from_property": "38.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 32 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 973-961-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a810-71d2-a901-ecb0dbf822ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a810-71d2-a901-ecb0dbf822ac",
        "storage_key": "property/6767906449166334/019d0269-a810-71d2-a901-ecb0dbf822ac.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wzsxeFSwokRhvLXxTe087M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_b1469dd1-a6a3-4da1-b43f-639e0a079149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Siemens Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "62 Flanders-Bartley Rd, Flanders, NJ 07836, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-8b14-705f-aee5-4e736d69082c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-8b14-705f-aee5-4e736d69082c",
        "storage_key": "property/6767906449166334/019d0269-8b14-705f-aee5-4e736d69082c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.siemens-healthineers.com/en-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=8501745944137260002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siemens-healthcare",
      "poi_latitude": "40.8359823",
      "poi_longitude": "-74.7067871",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-927-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XnjChacw4kR4lvrWuRE_HU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ffb692d0-2acd-4613-955a-c930f4d9c254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Picatinny Arsenal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "213 NJ-15, Wharton, NJ 07885, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-8c43-76dc-b0ac-253240eead28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-8c43-76dc-b0ac-253240eead28",
        "storage_key": "property/6767906449166334/019d0269-8c43-76dc-b0ac-253240eead28.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://home.army.mil/picatinny",
      "poi_directions_map_url": "https://maps.google.com/?cid=6390813921455506284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "picatinny-arsenal",
      "poi_latitude": "40.9170823",
      "poi_longitude": "-74.58051929999999",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a92a-730d-b9e5-203df505c83d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a92a-730d-b9e5-203df505c83d",
        "storage_key": "property/6767906449166334/019d0269-a92a-730d-b9e5-203df505c83d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSzGpX4Mw4kRbAP6zWa7sFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de423189-eb2f-48e3-9494-b8951e8a81f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Givaudan Fragrances Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "International Trade Center, 300 Waterloo Valley Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-8e32-7164-bb61-de92fc166ec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-8e32-7164-bb61-de92fc166ec1",
        "storage_key": "property/6767906449166334/019d0269-8e32-7164-bb61-de92fc166ec1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.givaudan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10170498081786973939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "givaudan-fragrances-corporation",
      "poi_latitude": "40.9076319",
      "poi_longitude": "-74.7341142",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-448-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafJsFS12w4kR8060qR7eJI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be301cbc-0648-46f2-bd8a-e07ea41df5f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Robertet Fragrances Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 International Dr, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-8e60-70ca-9aa3-a07813768d32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-8e60-70ca-9aa3-a07813768d32",
        "storage_key": "property/6767906449166334/019d0269-8e60-70ca-9aa3-a07813768d32.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.robertet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4741893392921058263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robertet-fragrances-inc",
      "poi_latitude": "40.8994739",
      "poi_longitude": "-74.72230569999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 201-337-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9ae2-7273-a2a2-82bbc8597188",
        "storage_key": "property/6767906449166334/019d0269-9ae2-7273-a2a2-82bbc8597188.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4QxuJ0Adw4kR19vUz-qWzkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ece9360f-2385-4ad5-8d6d-4e750c4bbe48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Seiko Instruments",
      "poi_type": "Major Employers & Offices",
      "poi_address": "650 Clark Dr, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-90e5-7605-b93e-5bbb93626541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-90e5-7605-b93e-5bbb93626541",
        "storage_key": "property/6767906449166334/019d0269-90e5-7605-b93e-5bbb93626541.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.seikousa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10822574180502215202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seiko-instruments",
      "poi_latitude": "40.9003219",
      "poi_longitude": "-74.72789759999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-691-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbsKeSl2w4kRIhomcOCBMZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_4a062a50-39cc-44c3-8401-d2ebfa969487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "FedEx Ship Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "675 Clark Dr, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-918a-7369-84df-2ad5634a097f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-918a-7369-84df-2ad5634a097f",
        "storage_key": "property/6767906449166334/019d0269-918a-7369-84df-2ad5634a097f.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://local.fedex.com/en-us/nj/budd-lake/arxa?cmp=LOC-1001545-3-2-971-1110000-US-US-EN-YEXTLISTFEDEXSC",
      "poi_directions_map_url": "https://maps.google.com/?cid=12268643339714715760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fedex-ship-center",
      "poi_latitude": "40.9018778",
      "poi_longitude": "-74.7273553",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-463-3339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcg5DSl2w4kRcGCoix36Qqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4d52371e-37fa-49cc-83d2-fff4e5204d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "UPS Customer Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "303 Waterloo Valley Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9422-714c-b1ed-a4f53b170a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-9422-714c-b1ed-a4f53b170a8c",
        "storage_key": "property/6767906449166334/019d0269-9422-714c-b1ed-a4f53b170a8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.ups.com/us/en/nj/mountolive/customer-center-003547.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222327681943240267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ups-customer-center",
      "poi_latitude": "40.9052914",
      "poi_longitude": "-74.7321358",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-742-5877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-9f2e-732e-b445-a896c7ee5f52",
        "storage_key": "property/6767906449166334/019d0269-9f2e-732e-b445-a896c7ee5f52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXYW7yx2w4kRS34Kyvgkf7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_98ae2269-ea71-4913-a79f-a2200e6ada9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Saint Clare's Dover Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 W Blackwell St, Dover, NJ 07801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-93d9-724c-814e-e243bd09b56a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-93d9-724c-814e-e243bd09b56a",
        "storage_key": "property/6767906449166334/019d0269-93d9-724c-814e-e243bd09b56a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://saintclares.com/locations/saint-clares-dover-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311546857722953505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-clares-dover-hospital",
      "poi_latitude": "40.884662",
      "poi_longitude": "-74.575925",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-989-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a392-759f-9be6-8a647c5547e3",
        "storage_key": "property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZnKgaQKw4kRIT8z_SDVd2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_94320471-4934-46a4-b450-32539bb732f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "poi_name": "Newton Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "175 High St, Newton, NJ 07860, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-963a-75fa-9c75-9f8d2edc0cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-963a-75fa-9c75-9f8d2edc0cb7",
        "storage_key": "property/6767906449166334/019d0269-963a-75fa-9c75-9f8d2edc0cb7.webp",
        "width": 512,
        "height": 288
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/newton-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=697909091300207399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newton-medical-center",
      "poi_latitude": "41.0577098",
      "poi_longitude": "-74.7683868",
      "poi_miles_from_property": "17.2",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 973-383-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-a392-759f-9be6-8a647c5547e3",
        "storage_key": "property/6767906449166334/019d0269-a392-759f-9be6-8a647c5547e3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH12NiBtww4kRJ-t28J54rwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a88d05d01c3586febbeb1d40",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6253fe4395d7cb742c0bc966",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e6a0f9c6ae14c8341e803d3e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a42f724654d14f54c6e09f5f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_06642214f9d6ad7f59e4dfc8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e3cb749893af7a71e19ff7c4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c6504c06-6040-4c01-bd5a-0e392828a913",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "rating": "5.0",
      "name": "",
      "text": "I was very apprehensive about moving in at Overlook at Flanders when I saw all of the negative reviews but it is so far from the truth. They offer incredible amenities, aren't strict, and are so attentive. They are constantly doing landscaping and construction making sure the place looks good. They are fast about plowing and come around multiple times. I made a request to have someone come look at my ceiling because there is a stain and they hired a roofing specialist to come out and take a look. Rent is very cheap for the areas and the apartments are spacious and updated. The staff isn't ever looking over your shoulder, it's a very laid back community. There's a hiking trail, pool, 2 dog parks, play grounds, and they are building a community center with a gym. Trash removal is extremely convenient. They literally pick up your garbage from the front door of the building 6 days a week in the evening hours. AND they have an area to leave trash if by chance you miss the opportunity. They used to have dumpsters but they were attracting bugs and animals so they do valet service instead. I'm really surprised that anyone has anything negative to say about this complex. It's a great place to live.",
      "date": "",
      "title": "I Love It Here"
    },
    {
      "id": "custom_ffcc9860-9eeb-4dd2-8c6e-e1ece773b287",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "rating": "5.0",
      "name": "",
      "text": "I've lived here for 2 years and I love it. The apartments are well maintained, the maintanence staff is great and the managers are awesome! If I ever have an issue with anything the property manager, Mary, is quick to respond and very helpful. They are professional and courteous. I would recommend living here for sure!\nAmy L.",
      "date": "",
      "title": "Great place to live!"
    },
    {
      "id": "custom_8428ac66-322e-4b03-9c9b-c64ad348a6b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "rating": "5.0",
      "name": "",
      "text": "A diamond in the rough in northern Jersey - the staff are unfailingly polite, helpful, and knowledgeable, and always eager to provide assistance or friendly conversation.  The apartments are spacious, well-maintained, well-furnished, and the development is gorgeous and full of friendly faces.  The location is very scenic, and close to nearly everything you might need.  Pet friendly almost to a fault - two dog parks and quite a few doggy-doo stations all over the development - with wonderful amenities, such as a pool and tennis court, plus laundry available in every building (and quite a few of the nicer apartments even have laundry in-unit.)  The price is excellent for all that's included, and includes trash valet service five days a week, 24-hour on-site maintenance, and in some cases, even includes heating.  \nThis apartment is delightful, and I couldn't be happier to be living here.",
      "date": "",
      "title": "Exactly what we needed, when we needed it"
    },
    {
      "id": "custom_ef192af9-6c6e-462c-9152-22366f9d7cc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "rating": "5.0",
      "name": "",
      "text": "Quiet. Pet Friendly. Close to Trade Center and tons of local shop. Went for the upgraded unit to include personal washer/dryer in basement. and heat/ hot water included  with newer appliances. The rental office and staff are helpful and repairs are done quickly.  Pool access. Pet playground.  Great place to get away from the city but still  central to shopping and  schools.",
      "date": "",
      "title": "Great place for the extra money"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9fa188e1-dc33-4976-975e-abea3807a78f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/019fa54d-9ee0-77b8-a3e9-6194fa5a2922.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa54d-9ee0-77b8-a3e9-6194fa5a2922",
        "storage_key": "property/6767906449166334/019fa54d-9ee0-77b8-a3e9-6194fa5a2922.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Overlook at Flanders Tours",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6307c7a0d70b313f073870db&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_52d155b420f2256df157be0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429467",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 400,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_80b664374877169cfa4c7485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429468",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_22587c52290573fca3c84f91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429469",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b22c2a4f61b4f331ba95e949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429470",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8e14eafe0156b6eeb5c9c0e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429471",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 95,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ea220414b5fc44b5388191d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429472",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_57b54b271c7f429831ef5f07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429473",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a9f036e0594fda7c00ec0844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429474",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f1847d2a487d4a51ebc8ce2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429476",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ce139fd72f8ae9e7ad698efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429477",
      "name": "Trash Service",
      "description": "false",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f2867f974fa200c98388926d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "429479",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_63712aa6037465d2f045499c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "541015",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_11e22513d6dccb07b2e5fe95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "541016",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1112f958293b25b8712eb6bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "543102",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a5a2e25a183ef8df1969da42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "543115",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_110e9ef83e590c32242cf7d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "543135",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dad25edbf2d780225319121a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "835210",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_705c9511e9135e0c6e894953",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "835212",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a07dc118d96f7c6a6301b2aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "835215",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2f604e39358501fbf9df27f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "835217",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c4db066550a2904d7a9f74e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "engrain",
      "external_id": "835242",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a31a8-bbbf-7599-a896-f43af5816a13",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Overlook at Flanders property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334"
    },
    {
      "lead_collector_id": "019c3043-8198-7232-8034-af6fbd401f95",
      "lead_source": "FACEBOOK_ADS",
      "name": "overlook-at-flanders",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334"
    },
    {
      "lead_collector_id": "019c3043-8209-7660-82f4-088535aed1b6",
      "lead_source": "LANDING_PAGE",
      "name": "overlook-at-flanders",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-mount-olive-nj-647",
      "search_query": "pet friendly apartments Mount Olive NJ",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Mount Olive, NJ",
      "h2_subtitle": "Discover pet-friendly living at Overlook at Flanders. Your furry friends will love the dog park in our Mount Olive, NJ community.",
      "page_copy": "At Overlook at Flanders, we welcome pets with open arms in our Mount Olive, NJ community. Our pet-friendly apartments ensure that your four-legged companions feel just as at home as you do. With a dedicated dog park on-site, your pets will enjoy exercise and socialization right at their doorstep.\n\nBeyond accommodating pets, our community offers a range of amenities to enhance your living experience. Enjoy our sparkling swimming pool, participate in vibrant resident activities, and take advantage of on-site maintenance. Our thoughtfully designed one and two-bedroom homes offer the perfect retreat after a day of enjoying all the nearby local attractions with your pets. Find your forever home at Overlook at Flanders, where everyone, including your pets, is part of the family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Mount Olive, NJ",
      "seo_description": "Find pet-friendly apartments at Overlook at Flanders, Mount Olive, NJ. Enjoy a dog park and more. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-with-pool-morris-county-194",
      "search_query": "apartments with a swimming pool in Morris County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Morris County",
      "h2_subtitle": "Enjoy the sparkling swimming pool at Overlook at Flanders in Morris County. Our community offers ideal amenities for your relaxation and fun.",
      "page_copy": "Looking for apartments with a swimming pool in Morris County? Discover Overlook at Flanders, where leisure and luxury go hand in hand. Dive into our beautiful swimming pool that offers a refreshing escape from the everyday hustle. It’s perfect for morning laps or a relaxing afternoon by the water.\n\nOur community in Mount Olive not only features a stunning pool but also provides a plethora of other amenities. From a vibrant social life in the clubhouse to convenient flex rent payments, we've got it all covered. With spacious one and two-bedroom floor plans, Overlook at Flanders offers a perfect retreat infused with comfort and convenience. Experience premier apartment living right here in Morris County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Morris County",
      "seo_description": "Overlook at Flanders offers apartments with a swimming pool in Morris County. Enjoy relaxing amenities and more. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "ev-charging-station-apartments-flanders-70",
      "search_query": "EV charging station apartments near Flanders",
      "category": "Amenity",
      "h1_title": "EV Charging Station Apartments near Flanders",
      "h2_subtitle": "Discover EV-friendly living at Overlook at Flanders. Enjoy sustainable features and amenities in our community near Flanders, NJ.",
      "page_copy": "Join the green movement with Overlook at Flanders, where our apartments near Flanders offer thoughtful features like an EV charging station. Our community is committed to sustainable living, providing convenience to residents who drive electric vehicles.\n\nLocated in Mount Olive, NJ, Overlook at Flanders offers inviting one and two-bedroom homes with features beyond just eco-friendly amenities. Enjoy our refreshing swimming pool and engaging resident activities, ensuring there's always something fun and exciting happening. With a welcoming atmosphere and dedicated on-site maintenance, our community is designed to elevate your living standard while reducing your carbon footprint. Visit us today to see how Overlook at Flanders can be your sustainable home choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "EV Charging Station Apartments Near Flanders",
      "seo_description": "Overlook at Flanders offers EV charging station apartments near Flanders. Enjoy green living and convenient amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "mount-olive-nj-fitness-center-apartments-441",
      "search_query": "Mount Olive NJ fitness center apartments",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Mount Olive, NJ",
      "h2_subtitle": "Stay active at Overlook at Flanders in Mount Olive, NJ. Our community offers convenient fitness options among numerous amenities.",
      "page_copy": "Overlook at Flanders in Mount Olive, NJ, provides a perfect blend of convenience and wellness-focused living. Our fitness center is designed to help you maintain an active lifestyle without having to leave the comfort of home. Whether you're looking to lift weights or enjoy a cardio session, our fitness amenities are well-equipped to support your goals.\n\nBeyond the fitness center, our pet-friendly community boasts an array of other amenities. Cool off in our sparkling swimming pool, or join engaging resident activities held regularly. With a variety of one and two-bedroom floor plans, Overlook at Flanders offers a warm and welcoming environment tailored to meet the diverse needs of our residents. Experience the vibrant and health-conscious living environment here in Mount Olive, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Mount Olive, NJ",
      "seo_description": "Find fitness center apartments at Overlook at Flanders in Mount Olive, NJ. Enjoy active and convenient living with great amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-flanders-nj-596",
      "search_query": "1 bedroom apartments flanders nj",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Flanders, NJ",
      "h2_subtitle": "Find your perfect 1 bedroom apartment at Overlook at Flanders. Located in scenic Flanders, NJ, our community offers comfort and modern amenities.",
      "page_copy": "Discover the charm of our 1 bedroom apartments in Flanders, NJ, at Overlook at Flanders. Thoughtfully designed, these units offer the perfect blend of comfort and style, making them an ideal choice for singles or couples seeking a welcoming environment.\n\nOur community doesn't just offer beautifully crafted interiors; it also boasts an impressive range of amenities. Residents can enjoy a refreshing swim in the pool, participate in vibrant community activities, or take their furry friends to our dog park. With features such as renovated kitchens and on-site maintenance, Overlook at Flanders is committed to providing an exceptional living experience. Explore what makes our community stand out by visiting today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Flanders, NJ",
      "seo_description": "Explore 1 bedroom apartments in Flanders, NJ at Overlook at Flanders. Enjoy modern design and great amenities. Schedule your visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "2-bedroom-apartment-mount-olive-nj-963",
      "search_query": "2 bedroom apartment mount olive nj",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Mount Olive, NJ",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Overlook at Flanders, nestled in the charming community of Mount Olive, NJ.",
      "page_copy": "Relocate to a spacious and comfortable 2 bedroom apartment in Mount Olive, NJ, at Overlook at Flanders. Perfectly suited for families or roommates, our apartments offer ample living space and a multitude of modern conveniences.\n\nAt Overlook at Flanders, residents enjoy more than just a place to live. Our community is rich with amenities, including a welcoming clubhouse, a beautifully maintained swimming pool, and a dedicated dog park for pet enthusiasts. Each apartment features renovated kitchens, providing a charming and functional living environment. Discover the exceptional lifestyle awaiting you in Mount Olive, NJ, by scheduling a tour of our 2 bedroom offerings today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Mount Olive, NJ",
      "seo_description": "Find spacious 2 bedroom apartments at Overlook at Flanders in Mount Olive, NJ. Enjoy modern amenities and a welcoming community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-near-mountain-view-elementary-school-flanders-363",
      "search_query": "apartments near mountain view elementary school flanders",
      "category": "School",
      "h1_title": "Apartments Near Mountain View Elementary School",
      "h2_subtitle": "Discover family-friendly living at Overlook at Flanders, just minutes from Mountain View Elementary School in Flanders.",
      "page_copy": "Families seeking convenience and educational excellence will find a welcoming home at Overlook at Flanders, strategically located near Mountain View Elementary School in Flanders. Our apartments are perfect for those who value proximity to quality education and community living.\n\nOverlook at Flanders offers more than just an ideal location. Residents have access to a wealth of amenities including a sparkling swimming pool, a vibrant clubhouse, and lovely green spaces for family relaxation. Our pet-friendly community ensures that even furry family members feel at home. Explore the ease and comfort of living so close to Mountain View Elementary School by scheduling a tour of our family-friendly community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mountain View Elementary School",
      "seo_description": "Live near Mountain View Elementary in Flanders at Overlook at Flanders. Family-friendly apartments with great amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "overlook-at-flanders-near-tinc-road-school-nj-802",
      "search_query": "overlook at flanders near tinc road school nj",
      "category": "School",
      "h1_title": "Overlook at Flanders by Tinc Road School",
      "h2_subtitle": "Experience convenient living at Overlook at Flanders, situated near Tinc Road School in NJ. An ideal location for families wanting quality education nearby.",
      "page_copy": "Discover the unmatched convenience of living at Overlook at Flanders, ideally located near Tinc Road School in NJ. Our community's prime positioning makes it an excellent choice for families who prioritize top-tier education without compromising on amenities and comfort.\n\nResidents enjoy thoughtfully designed one and two-bedroom apartments along with a range of modern amenities. Whether it's relaxing by the sparkling swimming pool, mingling in the vibrant community clubhouse, or enjoying a walk with pets in the dog park, Overlook at Flanders offers a lifestyle that meets diverse needs. Experience the perfect blend of community living and educational convenience by visiting us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overlook at Flanders Near Tinc Road School",
      "seo_description": "Live close to Tinc Road School at Overlook at Flanders, NJ. Family-friendly community with modern amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "mount-olive-high-school-nearby-apartments-155",
      "search_query": "mount olive high school nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Mount Olive High School",
      "h2_subtitle": "Find the perfect home at Overlook at Flanders, offering apartments near Mount Olive High School in NJ, ideal for students and families.",
      "page_copy": "Overlook at Flanders provides the perfect home for those seeking apartments near Mount Olive High School in NJ. Located in a family-friendly area, our community offers a seamless blend of comfort and convenience, making school commutes effortless.\n\nChoose from our spacious one and two-bedroom options, each designed with modern living in mind. Enjoy the benefits of community-centered amenities such as a sparkling swimming pool, a welcoming clubhouse, and pet-friendly spaces. Whether you're a student or a family prioritizing educational proximity along with leisure, Overlook at Flanders is the ideal place for you. Visit us and explore our vibrant community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mount Olive High School",
      "seo_description": "Explore Overlook at Flanders for apartments near Mount Olive High School, NJ. Enjoy modern amenities in a friendly community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-close-to-mt-olive-middle-school-07836-741",
      "search_query": "apartments close to mt olive middle school 07836",
      "category": "School",
      "h1_title": "Apartments Close to Mt. Olive Middle School",
      "h2_subtitle": "Experience community living at Overlook at Flanders, with apartments close to Mt. Olive Middle School in the 07836 area.",
      "page_copy": "At Overlook at Flanders, find your perfect home with the advantage of proximity to Mt. Olive Middle School, located in the 07836 area. Our community is ideal for families seeking to simplify their daily routines with easily accessible educational facilities.\n\nOffering a variety of one and two-bedroom apartment options, each residence is designed with comfort and modern amenities in mind. Residents appreciate our lush swimming pool, an engaging clubhouse, and access to scenic areas perfect for pets. For those prioritizing both education and enjoyable living, Overlook at Flanders delivers a community that supports all aspects of life. Come and see what makes our location and amenities such a sought-after choice!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mt. Olive Middle School",
      "seo_description": "Discover Overlook at Flanders apartments close to Mt. Olive Middle School, 07836. Enjoy modern living with top amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "sandshore-elementary-school-nearby-residences-morris-county-1",
      "search_query": "sandshore elementary school nearby residences morris county",
      "category": "School",
      "h1_title": "Residences Near Sandshore Elementary School",
      "h2_subtitle": "Find ideal residences near Sandshore Elementary School in Morris County at Overlook at Flanders, blending community with educational accessibility.",
      "page_copy": "Overlook at Flanders offers an ideal residence for families seeking proximity to Sandshore Elementary School in Morris County. Our community ensures that you live in a vibrant environment while having the convenience of easy access to quality education.\n\nOur modern one and two-bedroom apartments provide a comfortable retreat within a lively community atmosphere, complete with desirable amenities such as a sparkling swimming pool, a welcoming clubhouse, and a convenient dog park. Being close to Sandshore Elementary not only makes school routines smooth and efficient but also enriches family life with added convenience and quality living. Explore how Overlook at Flanders can be the perfect home for your family today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Sandshore Elementary School",
      "seo_description": "Explore residences near Sandshore Elementary School, Morris County, at Overlook at Flanders. Enjoy convenient living with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "county-college-of-morris-nearby-apartments-117",
      "search_query": "county college of morris nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near County College of Morris",
      "h2_subtitle": "Explore conveniently located apartments near County College of Morris at Overlook at Flanders, offering comfort and community access.",
      "page_copy": "At Overlook at Flanders, you’ll find the perfect home situated conveniently near County College of Morris. Ideal for students and academics, our community offers both accessibility and comfort, just a short distance from campus.\n\nEnjoy life in one of our modern one and two-bedroom apartments, complete with essential amenities designed to enhance your living experience. Our on-site features include a sparkling pool, a vibrant clubhouse, and a welcoming environment, making it ideal for balancing studies with recreation and relaxation. Overlook at Flanders provides not just a home, but a supportive community close to County College of Morris, ensuring you have everything you need within reach. Visit us today to discover why our location is perfect for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near County College of Morris",
      "seo_description": "Find Overlook at Flanders apartments near County College of Morris. Enjoy modern living and amenities with a short commute. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-near-morristown-medical-center-nj-52",
      "search_query": "apartments near morristown medical center nj",
      "category": "Hospital",
      "h1_title": "Find Apartments Near Morristown Medical Center",
      "h2_subtitle": "Discover apartments near Morristown Medical Center, NJ, at Overlook at Flanders. Enjoy a perfect blend of convenience, comfort, and community.",
      "page_copy": "Located within easy commuting distance to Morristown Medical Center, Overlook at Flanders offers an ideal location for healthcare professionals and patients seeking comfort and convenience. Our community provides a peaceful home base with modern amenities designed to enhance your lifestyle.\n\nChoose from our thoughtfully designed one and two-bedroom apartments, which offer desirable features like wall-to-wall carpeting and renovated kitchens. Residents also enjoy access to a sparkling swimming pool, a vibrant clubhouse, and a pet-friendly environment. With flexible rent payment options and dedicated on-site maintenance, Overlook at Flanders ensures a seamless living experience close to Morristown Medical Center, NJ. Schedule a tour today and see why we are a preferred choice for those working in or visiting the medical center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Morristown Medical Center, NJ",
      "seo_description": "Explore apartments near Morristown Medical Center, NJ, at Overlook at Flanders. Perfect for medical professionals with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "mount-olive-apartments-near-hackettstown-medical-center-50",
      "search_query": "mount olive apartments near hackettstown medical center",
      "category": "Hospital",
      "h1_title": "Mount Olive Apartments Near Hackettstown Medical",
      "h2_subtitle": "Discover Mount Olive apartments near Hackettstown Medical Center with Overlook at Flanders, offering convenience and a welcoming community.",
      "page_copy": "Overlook at Flanders provides the perfect living solution for those seeking apartments in Mount Olive near Hackettstown Medical Center. Our community is ideal for medical professionals and patients looking for easy access to work or care, while enjoying a comfortable home environment.\n\nChoose from charming one and two-bedroom apartments that boast modern designs and convenient features such as wall-to-wall carpeting and renovated kitchens. Residents also benefit from top-notch amenities including an on-site swimming pool, a vibrant clubhouse, and an engaging resident activity program. At Overlook at Flanders, you can experience a supportive and vibrant community while being close to Hackettstown Medical Center. Contact us today for a tour and see why our location and offerings make us a top choice for apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mount Olive Apartments Near Hackettstown Medical",
      "seo_description": "Find Mount Olive apartments near Hackettstown Medical Center at Overlook at Flanders, offering modern amenities and an ideal location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-near-turkey-brook-park-nj-916",
      "search_query": "apartments near Turkey Brook Park NJ",
      "category": "Park",
      "h1_title": "Find Apartments Near Turkey Brook Park, NJ",
      "h2_subtitle": "Explore the beauty and convenience of living near Turkey Brook Park in NJ with apartments at Overlook at Flanders.",
      "page_copy": "Living at Overlook at Flanders means enjoying the perfect blend of nature and convenience. Our apartments are ideally located near Turkey Brook Park, NJ, making it a dream spot for those who love the outdoors. Whether you're into hiking, sports, or simple leisurely walks, Turkey Brook Park offers an abundance of recreational activities just moments away.\n\nOur community boasts a variety of one and two-bedroom apartments, designed with your comfort in mind. Enjoy modern amenities such as a refreshing swimming pool, a vibrant resident activities program, and a welcoming dog park, all contributing to a quality lifestyle. Overlook at Flanders offers not just proximity to the natural beauty of Turkey Brook Park, but also a dynamic living experience with thoughtful on-site amenities. Schedule a visit today and discover your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Turkey Brook Park, NJ",
      "seo_description": "Discover apartments near Turkey Brook Park, NJ, at Overlook at Flanders. Enjoy convenience, modern amenities, and proximity to outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "hopatcong-state-park-nearby-apartments-932",
      "search_query": "Hopatcong State Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Hopatcong State Park",
      "h2_subtitle": "Discover apartments near Hopatcong State Park at Overlook at Flanders. Enjoy scenic beauty and a welcoming community nearby.",
      "page_copy": "At Overlook at Flanders, you'll find the perfect apartments located near the breathtaking Hopatcong State Park. Ideal for those who cherish outdoor activities, our community offers easy access to the park's scenic trails, water activities, and picnic spots, making it a great place for adventure and relaxation.\n\nOur one and two-bedroom apartments offer a cozy sanctuary with features like wall-to-wall carpeting and renovated kitchens. Residents can indulge in the community's amenities, including a sparkling swimming pool, vibrant clubhouse, and engaging activities. Plus, with our pet-friendly environment, it's easy for the whole family, including furry friends, to enjoy life close to Hopatcong State Park. Discover a balanced lifestyle that combines nature's finest with comforting apartment living at Overlook at Flanders.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hopatcong State Park",
      "seo_description": "Find nearby apartments to Hopatcong State Park at Overlook at Flanders, offering modern living with easy access to natural beauty and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-by-hacklebarney-state-park-766",
      "search_query": "apartments by Hacklebarney State Park",
      "category": "Park",
      "h1_title": "Live Near Hacklebarney State Park Apartments",
      "h2_subtitle": "Explore stylish apartments by Hacklebarney State Park at Overlook at Flanders, perfect for those who love nature and a serene lifestyle.",
      "page_copy": "At Overlook at Flanders, experience the tranquility of living in apartments by Hacklebarney State Park. Our location offers nature enthusiasts and those seeking peace and quiet the ideal place to call home, with the park's pristine trails and rivers just a short drive away.\n\nOur thoughtfully designed one and two-bedroom apartments are perfect for enjoying life close to nature. Immerse yourself in our community's amenities, such as a relaxing swimming pool, a dynamic clubhouse, and a welcoming dog park. With on-site maintenance and flexible rent payments, Overlook at Flanders provides a hassle-free living experience near Hacklebarney State Park. Step into a lifestyle where community and comfort meet nature's beauty—schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hacklebarney State Park",
      "seo_description": "Discover Overlook at Flanders, where apartments near Hacklebarney State Park offer serene living with modern amenities and a connection to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "schooleys-mountain-park-apartments-flanders-78",
      "search_query": "Schooley's Mountain Park apartments Flanders",
      "category": "Park",
      "h1_title": "Explore Flanders Apartments Near Schooley's Mountain Park",
      "h2_subtitle": "Discover the serene lifestyle of Flanders with apartments near Schooley's Mountain Park, perfect for outdoor enthusiasts.",
      "page_copy": "Nestled in the heart of Flanders, Overlook at Flanders offers apartments perfectly positioned near Schooley's Mountain Park. This is an ideal setting for those who crave a blend of natural beauty and convenience. Enjoy access to the park's stunning trails and picnic areas, making outdoor leisure a regular part of your routine.\n\nOur community provides one and two-bedroom apartments with modern amenities such as renovated kitchens and wall-to-wall carpeting. With a welcoming dog park and a vibrant clubhouse for resident activities, our community fosters a lively yet relaxing atmosphere. Enjoy proximity to Schooley's Mountain Park while benefiting from the comprehensive amenities at Overlook at Flanders. Embrace a lifestyle where nature meets comfort, and schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Schooley's Mountain Park Apartments in Flanders",
      "seo_description": "Find apartments near Schooley's Mountain Park at Overlook at Flanders. Enjoy the perfect balance of nature and community living in Flanders.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-close-to-willowwood-arboretum-morris-county-936",
      "search_query": "apartments close to Willowwood Arboretum Morris County",
      "category": "Park",
      "h1_title": "Find Apartments Near Willowwood Arboretum",
      "h2_subtitle": "Discover apartments close to Willowwood Arboretum in Morris County, offering peaceful living at Overlook at Flanders.",
      "page_copy": "Settle into a serene lifestyle with apartments close to Willowwood Arboretum in Morris County at Overlook at Flanders. Our community offers the perfect location for nature enthusiasts who value the beauty and tranquility of the arboretum's gardens and walking paths, all within easy reach.\n\nOur one and two-bedroom apartments are designed with comfort in mind, featuring renovated kitchens and plush wall-to-wall carpeting. Residents can also enjoy our vibrant clubhouse, sparkling swimming pool, and well-kept dog park. With these amenities and the picturesque Willowwood Arboretum nearby, Overlook at Flanders provides an idyllic setting for relaxation and community engagement. Experience the charm of Morris County living by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Willowwood Arboretum",
      "seo_description": "Explore Overlook at Flanders for apartments near Willowwood Arboretum in Morris County, offering a peaceful setting with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166334",
      "source": "custom",
      "page_item_url": "apartments-near-newark-liberty-airport-nj-69",
      "search_query": "apartments near Newark Liberty International Airport NJ",
      "category": "Transit",
      "h1_title": "Convenient Apartments Near Newark Liberty Airport",
      "h2_subtitle": "Enjoy modern living with easy access to Newark Liberty International Airport, NJ, at Overlook at Flanders.",
      "page_copy": "For those seeking convenience and comfort, Overlook at Flanders in Mount Olive, NJ, offers the perfect solution with apartments near Newark Liberty International Airport. Whether you're a frequent flyer or work in aviation, our community provides quick access to the airport while offering a tranquil living environment away from the bustle.\n\nOur spacious one and two-bedroom apartments are equipped with renovated kitchens and wall-to-wall carpeting, ensuring a cozy living experience. Residents can take advantage of our community amenities, including a sparkling swimming pool, on-site maintenance, and a welcoming dog park. With the vibrant community life and proximity to the airport, Overlook at Flanders represents an ideal choice for residents who value accessibility and serenity. Schedule a visit today and see how convenient life can be!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool surrounded by lounge chairs and lush greenery, with a white pergola providing shade.",
        "public_id": "01a015da-df19-752b-861a-aaeeceb1e11e",
        "storage_key": "property/6767906449166334/01a015da-df19-752b-861a-aaeeceb1e11e.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Newark Liberty Airport NJ",
      "seo_description": "Discover Overlook at Flanders for apartments near Newark Liberty International Airport, NJ. Enjoy easy airport access with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5071"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976270468"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973414"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5Z3RJMJ6"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveoverlook.fatwin.com/api/websites/resources/1?x=K00yQmltL2ZlRDBhRmRtNnBCTjZIVGE0Myswa3RCN2RUUXhlV3NrS3l6cFdhRG5qYUtWNjkrSDBtMFhuT2JMUGlxWjFYbzRIRGtKTFlXdHVFN3VSL0E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Stadium House"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "51224418207"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/ryzvgomowln"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9548e922-43e6-11ef-85f7-e7e9ca046ea8"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548e922-43e6-11ef-85f7-e7e9ca046ea8/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548e922-43e6-11ef-85f7-e7e9ca046ea8/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkpiWnlDZlBPTXI3eUhMN0s2d0RIOVE9PSIsInZhbHVlIjoiaGd2K25qbFJDRXUrMEpVdy9pOEo4Zz09IiwibWFjIjoiZTNmZGRiNDlkOTA1ZWE5NGQzM2VlODQwMmRmNWY0ZWM5YjBiYTRiYmE5MTcxOThjNGFmMjQ2ZDVmMGY1ZDI5ZSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5071",
  "custom_repli_id": "9976270468",
  "custom_realpage_id": "4973414",
  "custom_google_gtm_id": "GTM-5Z3RJMJ6",
  "custom_perq_script_url": "https://liveoverlook.fatwin.com/api/websites/resources/1?x=K00yQmltL2ZlRDBhRmRtNnBCTjZIVGE0Myswa3RCN2RUUXhlV3NrS3l6cFdhRG5qYUtWNjkrSDBtMFhuT2JMUGlxWjFYbzRIRGtKTFlXdHVFN3VSL0E9PQ2",
  "custom_vibesites_theme": "Stadium House",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "51224418207",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/ryzvgomowln",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9548e922-43e6-11ef-85f7-e7e9ca046ea8",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548e922-43e6-11ef-85f7-e7e9ca046ea8/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548e922-43e6-11ef-85f7-e7e9ca046ea8/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkpiWnlDZlBPTXI3eUhMN0s2d0RIOVE9PSIsInZhbHVlIjoiaGd2K25qbFJDRXUrMEpVdy9pOEo4Zz09IiwibWFjIjoiZTNmZGRiNDlkOTA1ZWE5NGQzM2VlODQwMmRmNWY0ZWM5YjBiYTRiYmE5MTcxOThjNGFmMjQ2ZDVmMGY1ZDI5ZSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "d78681f9-d0fa-4d86-b3e3-9e84f1b4a09e",
  "custom_audioeye_site_hash": "b0f712161bb2b000991bc0e2909f6027"
};

export const generatedAt = '2026-10-22T20:06:22.818Z';
